export default {
	average_power_savings_per_ton_of_Paper:"平均吨纸电耗节省",
	CO2_price:"CO₂价格",
	"current_water_price":"水价",
	"total_wate_saving":"节水总量",
	"tiered_electricity_pricing":"分段电价",
	"annual_energy_savings_of_intelligent_systems": "智能系统年度节能总收益",
	"annual_electricity_savings_of_intelligent_systems": "智能系统年度节电收益",
	"annual_coal_savings_of_intelligent_systems": "智能系统年度节煤收益",
	"annual_co2_reduction_of_intelligent_systems": "智能系统年度CO₂排放收益",
	"annual_water_savings_of_intelligent_systems": "智能系统年度节水收益",
	"节水量":"节水量",
	"水费单价":"水费单价",
	"图表最多展示6个测点":"图表最多展示6个测点！",
"最多置顶展示两个测点":"最多置顶展示两个测点",
	'返回机组':'返回机组',
	电厂:'电厂-',
	"设备巡检":"设备巡检",
	"编辑账号":"编辑账号",
	"设备出厂":"设备出厂",
	"安装调试":"安装调试",
	"设备质保到期":"设备质保到期",
	"设备开始运行":"设备开始运行",
	"签订维保合同":"签订维保合同",
	"维保服务开始":"维保服务开始",
	"维保服务到期":"维保服务到期",
	"橙色预警":"橙色预警",
	"红色预警":"红色预警",
	"绿色预警":"绿色预警",
	"数据丢失":"数据丢失",
	"设备维修":"设备维修",
	"设备保养":"设备保养",
	"故障排除":"故障排除",
	"设备报废":"设备报废",
	"下次保养":"下次保养",
	"请选择负责省份":"请选择负责省份！",	
	"创建了一个新的请求":"创建了一个新的请求",
	"请求":"请求",
	"已被升级为工单":"已被升级为工单",
	"已完成":"已完成",
	"已被取消":"已被取消",
	"新的工单":"新的工单",
	"工单转派申请":"工单转派申请",
	"工单已完成":"工单已完成",
	"工单已关闭":"工单已关闭",
	//工单编号{p1}-{p2}工程师已完成执行过程，请您查看检验并签字确认
	"工单编号":"工单编号",
	"工程师已完成执行过程":"工程师已完成执行过程",
	"请您查看检验并签字确认":"请您查看检验并签字确认",
	"默认接受人":"默认接受人",
	"默认联系人":"默认联系人",
	"资质证书上传":"资质证书上传",
	"新增账号":"新增账号",
	"KA客户类型":"KA客户类型",
	"总览": '总览',
	"云图": '云图',
	"设备云图":"设备云图",
	"工单": '工单',
	"商机": '商机',
	"主页": '主页',
	"能耗配置":"能耗配置",
	"智能运维":"智能运维",
	"健康监控": "健康监控",
	"事件管理": "事件管理",
	"图谱分析": "图谱分析",
	"专家系统服务": "专家系统服务",
	"销售服务工程师":"销售服务工程师",
	"技术服务工程师":"技术服务工程师",
	"服务回访导出":"服务回访导出",
	"服务回访导入":"服务回访导入",
	"保存": "保存",
	"智能诊断":"智能诊断",
	"是否技改":"是否技改",
	"历史电流导入":"历史电流导入",
	"历史电流数据导入":"历史电流数据导入",
	"点击上传历史电流数据":"点击上传历史电流数据",
	"建议按照年度上传历史电流数据进行分析对比":"建议按照年度上传历史电流数据进行分析对比",
	"技改前数据请上传一个自然年数据":"技改前数据请上传一个自然年数据",
	"点击下载":"点击下载",
	"技改前":"技改前",
	"技改后":"技改后",
	"实际数据":"实际数据",
	"其他":"其他",
	"模型":"模型",
	"在此输入数据快照名称":"在此输入数据快照名称",
	"device_work_order":{
		"贴二维码":"申请贴二维码",
		"设备维修":"申请设备维修",
		"设备保养":"申请设备保养",
		"安装调试":"申请安装调试",
		"故障排除":"申请故障排除",
		"延保服务":"申请延保服务",
	},
	'大于200台':'大于200台', 
	'100～200台':'100～200台', 
	'小于100台':'小于100台',
	查看设备:"查看设备",
	北京: "北京",
	上海: "上海",
	天津: "天津",
	重庆: "重庆",
	河北: "河北",
	山西: "山西",
	辽宁: "辽宁",
	吉林: "吉林",
	黑龙江: "黑龙江",
	浙江: "浙江",
	福建: "福建",
	山东: "山东",
	河南: "河南",
	湖北: "湖北",
	湖南: "湖南",
	广东: "广东",
	海南: "海南",
	四川: "四川",
	贵州: "贵州",
	云南: "云南",
	江西: "江西",
	陕西: "陕西",
	青海: "青海",
	甘肃: "甘肃",
	广西: "广西",
	新疆: "新疆",
	内蒙古: "内蒙古",
	西藏: "西藏",
	宁夏: "宁夏",
	台湾: "台湾",
	香港: "香港",
	澳门: "澳门",
	安徽: "安徽",
	江苏: "江苏",
	今年电耗: "今年电耗",
	去年电耗: "去年电耗",
	今年:'今年',
	"佶缔纳士是您值得信赖的合作伙伴,了解我们的CARE服务,让您的设备保持高效稳定的运行,为您的生产经营保驾护航！":
		"佶缔纳士是您值得信赖的合作伙伴,了解我们的CARE服务,让您的设备保持高效稳定的运行,为您的生产经营保驾护航！",
	service_request: "服务请求",
	更换轴承润滑脂: "更换轴承润滑脂",
	清理换热器: "清理换热器",
	更换减速机润滑油: "更换减速机润滑油",
	"仪表（真空、压力、温度、液位）检查（校核）":
		"仪表（真空、压力、温度、液位）检查（校核）",
	更换填料: "更换填料",
	联轴器对中检查: "联轴器对中检查",
	清理工作液管线滤网: "清理工作液管线滤网",
	电机更换润滑脂: "电机更换润滑脂",
	真空泵间隙检查并调整: "真空泵间隙检查并调整",
	保养内容: "保养内容",
	轴承风险无: "轴承风险无",
	汽蚀风险无: "汽蚀风险无",
	search: "搜索",
	download: "下载",
	Auditing: "设备巡检",
	延保服务: "延保服务",
	提醒: "提醒",
	"本次检测健康，无气蚀风险，无轴承相关风险":
		"本次检测健康，无气蚀风险，无轴承相关风险",
	轴承和泵体振动正常: "轴承和泵体振动正常",
	无较大噪音: "无较大噪音",
	泵腔内无较大异响: "泵腔内无较大异响",
	"设备运行环境良好，无灰尘、杂质等污染物进入轴承区域":
		"设备运行环境良好，无灰尘、杂质等污染物进入轴承区域.",
	"请遵照佶缔纳士原厂使用说明书上的维护建议进行定期检修，维修设备健康和稳定高效的运行。":
		"请遵照佶缔纳士原厂使用说明书上的维护建议进行定期检修，维修设备健康和稳定高效的运行。",
	"泵运行平稳，没有异常噪音或振动": "泵运行平稳，没有异常噪音或振动",
	"液体流量和压力在正常范围内，没有出现剧烈波动":
		"液体流量和压力在正常范围内，没有出现剧烈波动",
	"泵壳和叶轮表面无明显汽蚀损伤或腐蚀痕迹。":
		"泵壳和叶轮表面无明显汽蚀损伤或腐蚀痕迹。",
	暂无风险: "暂无风险",
	device_event_description:{
		"进入健康状态":"进入健康状态",
		"进入亚健康状态":"进入亚健康状态",
		"进入异常状态":"进入异常状态",
	},
	故障说明: {
		'轴承温度过高': '轴承温度过高',
		'工作液温度过高': '工作液温度过高',
		'换热器堵塞': '换热器堵塞',
		'建议拆除入口临时开车滤网': '建议拆除入口临时开车滤网',
		'清洗板式换热器 检查循环冷却水系统': '清洗板式换热器,检查循环冷却水系统',
		'一线氢压机投氢气运行，提到满负荷后分离器液环波动大，最高从15cm至30cm。': '一线氢压机投氢气运行，提到满负荷后分离器液环波动大，最高从15cm至30cm。',
		'一线氢压机试车时非驱动端轴承温度高。': '一线氢压机试车时非驱动端轴承温度高。',
		'叶轮叶片裂纹及断裂': '叶轮叶片裂纹及断裂'

	},
	结垢: '结垢',
	气蚀分析: '气蚀分析',
	无法启动: '无法启动',
	轴承故障: '轴承故障',
	泄漏: '泄漏',
	真空度不足: '真空度不足',
	真空泵NDE轴承水平振动: '真空泵NDE轴承水平振动',
	真空泵NDE轴承轴向振动: '真空泵NDE轴承轴向振动',
	"t-menu": "菜单",
	'root_sn_exists': '泵头序列号重复，请重新输入！',
	'group_sn_exists': '机组序列号重复，请重新输入！',
	//706
	气蚀状态低风险预警: '气蚀状态低风险预警',
	气蚀状态高风险预警: '气蚀状态高风险预警',

	"IIoT maintenance management platform": "智能化运维管理平台",
	"Intelligent Dry Hybrid Vacuum Unit": "智能干式复合真空机组",
	"Negative Pressure Vacuum Unit": "中央真空机组",
	"iV706 Intelligent Vacuum Unit": "iV706智能真空机组",
	"Unit Information": "设备信息",
	"Name": "设备名称",
	"Serial No.": "设备序列号",
	"Type": "设备型号",
	"Suction flow": "吸入流量",
	"Extreme Vacuum": "极限真空",
	"Back pressure": "背压",
	"Equipment Alarm": "设备预警",
	"Equipment running time": "设备运行时长",
	"Hint": "提醒",
	"Recent Events": "设备预警",
	"Notice": "提醒",
	"Error": "错误",
	"Warning": "警告",
	"Maintenance Service": "设备保养计划",
	"Last Service Date": "上次保养时间",
	"Last Service Level": "上次保养名称",
	"Next Service Time": "下次保养时间",
	"Service Level": "下次保养名称",
	"Duration from last maintenance run": "距上次保养运行时长",
	"Maintenance records": "保养记录",
	"Inlet temperature": "入口温度",
	"Inlet pressure": "入口压力",
	"Electric current": "机组运行电流",
	"Suction Pressure": "机组吸气压力",
	"Screw pump motor": "螺杆泵电机",
	"Screw pumps": "螺杆泵",
	"Roots Pumps": "罗茨泵",
	"Roots pump motor": "罗茨泵电机",
	"Current": "电流",
	"Rotation Speed": "转速",
	"Power consumption": "功耗",
	"Bearing temperature": "轴承温度",
	"X-directional vibration": "X向振动",
	"Y-directional vibration": "Y向振动",
	"Cooling water temperature": "冷却水温度",
	"Cooling water flow": "冷却水流量",
	"Station Current": "整站运行电流",
	"Station suction pressure": "整站吸气压力",
	"Unit Status": "机组状态",
	"Unit Data": "机组数据",
	"Total running time of equipment": "设备总运行时长",
	"Last boot time": "上次开机时间",
	"Operation/stop of the whole station": "整站运行/停止",
	"Roots pump motor vibration": "罗茨泵电机振动",
	"Roots pump vibration": "罗茨泵振动",
	"Screw pump motor vibration": "螺杆泵电机振动",
	"Screw pump vibration": "螺杆泵振动",
	"High frequency vibration analysis": "振动分析",
	"Overview": "运行总览",
	"Intelligent Diagnosis": "智能诊断",
	"Vibration Analysis": "振动分析",
	"Simulation": "数据仿真",
	"Equipment operation reference": "设备运行参考",
	"Parameters": "参数",
	"Run": "运行",
	"Reference": "参考",
	"Roots pump motor real-time rotational speed": "罗茨泵电机实时转速",
	"Roots pump motor real-time current": "罗茨泵电机实时电流",
	"Roots pump inlet pressure": "罗茨泵入口压力",
	"Screw pump motor real-time rotational speed": "螺杆泵电机实时转速",
	"Screw pump motor real-time current": "螺杆泵电机实时电流",
	"Screw pump inlet pressure": "螺杆泵入口压力",
	"Diagnosis conclusion": "诊断结论",
	"Alarm number": "报警编号",
	"Fault Type": "故障类型",
	"Processing suggestions": "处理建议",
	"Diagnosis time": "诊断时间",
	"Diagnostic Report": "诊断报告",
	"Roots pump motor non-drive end level": "罗茨泵电机非驱动端水平",
	"Roots pump motor drive end level": "罗茨泵电机驱动端水平",
	"Screw pump motor non-driven end level": "螺杆泵电机非驱动端水平",
	"Screw pump motor drive end level": "螺杆泵电机驱动端水平",
	"Roots pump non-drive end level": "罗茨泵非驱动端水平",
	"Roots pump drive end - horizontal direction": "罗茨泵驱动端水平",
	"Screw pump non-driven end level": "螺杆泵非驱动端水平",
	"Screw pump drive end level": "螺杆泵驱动端水平",
	"Peak acceleration": "加速度峰值",
	"Speed RMS": "速度有效值",
	"Trend graph": "(趋势图)",
	"Waveform graph": "(波形图)",
	"Horizontal-acceleration": "加速度",
	"Peak envelope": "包络峰值",
	"Bearing Status": "轴承状态",
	"High Frequency Vibration Spectrum": "高频振动图谱",
	"Roots pump drive end - horizontal direction- effective value of speed (mm/s) (trend graph)": "罗茨泵驱动端水平-速度有效值(mm/s)（趋势图）",
	"Horizontal-acceleration (m/s^2) at the driving end of the Roots pump (waveform graph)": "罗茨泵驱动端水平-加速度(m/s^2)（波形图）",
	"Roots pump drive end - horizontal direction-envelope (m/s^2) (waveform graph)": "罗茨泵驱动端水平-包络(m/s^2)（波形图）",
	"Horizontal bearing temperature at the drive end of the Roots pump (°C)": "罗茨泵驱动端水平轴承温度(°C)",
	"Vacuum pump station room": "真空泵站房",
	"Energy Efficiency Overview": "能效概览",
	"Total electricity bill for the month": "本月总电费",
	"Year-on-year": "同比",
	"link relative ratio": "环比",
	"ten thousands": "万元",
	"Rmb": "元",
	"Ton": "吨",
	"Rmb/Nm": "元/Nm³",
	"Monthly aspirated electricity consumption": "月吸气电耗",
	"Monthly cumulative inhalation": "月累计吸气",
	"Monthly suction unit price": "月吸气单价",
	"Monthly suction electricity price": "月吸气电价",
	"Total cumulative monthly electricity consumption": "月累计总电耗",
	"Unit No. 2": "2号机组",
	"Unit No. 1": "1号机组",
	"Shutdown": "停机",
	"Failure": "故障",
	"Monthly cumulative running time": "月累计运行时间",
	"22 days 9 hours": "22天9小时",
	"Suction power consumption": "吸气电耗",
	"Suction unit price": "吸气单价",
	"Suction efficiency": "吸气效率",
	"Effective power": "有效功率",
	"Power loss": "损耗功率",
	"Daily inspiratory electricity consumption": "每日吸气电耗",
	"August Energy Efficiency Details": "8月能效详情",
	"Unit No. 1 suction power consumption": "1号机组吸气电耗",
	"Vacuum station integrated suction power consumption": "真空站综合吸气电耗",
	"Daily Inhalation": "每日吸气",
	"Unit Aspiration": "号机组吸气",
	"Vacuum station suction": "真空站吸气",
	"Vacuum station integrated suction": "真空站综合吸气",
	"Daily electricity consumption": "每日电耗",
	"Current consumption of the unit": "机组电耗",
	"Vacuum power consumption": "真空电耗",
	"Monthly flat, valley and peak power consumption ratio": "月平、谷、峰电耗占比",
	"Peak hour power consumption": "峰时电耗",
	"Valley time electricity consumption": "谷时电耗",
	"Usual electricity consumption": "平时电耗",
	"Monthly inhalation electricity bill": "月吸气电费",
	"Usual electricity bill": "平时电费",
	"Peak hour electricity rates": "峰时电费",
	"Valley hour electricity rates": "谷时电费",
	"Total Aspiration Cost": "总吸气成本",
	"Aspiration cost": "吸气成本",
	"Customized mode": "自定义模式",
	"Constant pressure mode": "定压模式",
	"Quantitative mode": "定量模式",
	"Inlet Pressure": "系统入口压力",
	"System inlet temperature": "系统入口温度",
	"System entrance traffic": "系统入口流量",
	"Inlet traffic": "入口流量",
	// "Inlet pressure": "入口压力",
	"Outlet Pressure": "系统出口压力",
	"Roots pump motor X-axis vibration": "罗茨泵电机X轴振动",
	"Screw pump motor X-axis vibration": "螺杆泵电机X轴振动",
	"Principle Description": "原理说明",
	"Schematic diagram of neurons": "神经元示意图",
	"Hidden layer activation function": "隐藏层激活函数",
	"Each neuron is connected to all neurons in the previous layer of the neural network layer. An n-dimensional vector space is divided into two parts with a hyperplane using a judgment boundary, and given an input vector, a scalar result is obtained by passing the activation function after finding the inner product of the input vector and the weight vector. The composite neural network combined by multilayer neurons connects multiple models in series during the transfer of process parameter relations to realize the digital simulation of the whole process.": "每一个神经元和前一层神经网络层中的所有神经元连接。把一个n维向量空间用一个超平面用判断边界分割成两部分，给定一个输入向量，求得输入向量与权向量的内积后，经激活函数传递，得到一个标量结果。由多层神经元组合后的复合神经网络，在工艺参数关系的传递过程中串连多个模型，实现工艺的全流程的数字仿真。",
	"Total operating hours of the equipment": "设备总运行时长",
	"Last start time": "上次开机时间",
	"Whole station run/stop": "整站运行/停止",
	"Screw motor": "螺杆电机",
	"Roots motor": "罗茨电机",
	"Normal operation": "正常运行",
	"Water replenishment solenoid valve": "补水电磁阀",
	"Cooling fans": "冷却风机",
	"Centrifugal pump operating status": "离心泵运行状态",
	"Intelligent pump remote control / local": "智能泵远控/就地",
	"Intelligent pump emergency stop": "智能泵急停",
	"Liquid level": "液位",
	"Working water inlet temperature": "工作水入口温度",
	"Temperature inside the chassis": "机箱内温度",
	"Vacuum Inlet Pressure": "真空系统入口压力",
	"Motor current": "电机电流",
	"Working fluid temperature": "工作液温度",
	"Fan operation status": "风扇运行状态",
	"Centrifugal pump run/stop": "离心泵运行/停止",
	"Centrifugal pump ready/failure": "离心泵就绪/故障",
	"Water ring vacuum pump running/stopping": "水环真空泵运行/停止",
	"Water ring vacuum pump ready/failure": "水环真空泵就绪/故障",
	"Vacuum pump inlet valve": "真空泵入口阀",
	"Data Streaming": "实时数据",
	"View Details": "查看详情",
	"Vibration Charts": "振动数据",
	"Vacuum pump non-driving end bearing vibration": "真空泵非驱动端轴承振动",
	"Vacuum pump drive end bearing vibration": "真空泵驱动端轴承振动",
	"Vacuum unit current curve": "真空机组电流曲线",
	"Vacuum unit current": "真空机组电流",
	"Vacuum unit inlet pressure curve": "真空机组入口压力曲线",
	"Vacuum unit inlet pressure": "真空机组入口压力",
	"Heat exchanger temperature profile": "换热器温度曲线",
	"Working fluid inlet": "工作液入口",
	"Working fluid outlet": "工作液出口",
	"Cooling water inlet": "冷却水入口",
	"Cooling water outlet": "冷却水出口",
	"Remote control": "远控",
	"Alarm events": "报警事件",
	"The event log": "事件记录",
	"Event number": "事件编号",
	"type": "类型",
	"Affected equipment": "受影响设备",
	"Time of occurrence": "发生时间",
	"brief description": "简要描述",
	"Suggestions on troubleshooting causes": "故障原因分析建议",
	"Related process description": "相关工艺说明",
	"Relevant results": "相关结果",
	"Incident report": "事件报告",
	"Heat exchanger temperature curve": "换热器温度曲线",
	"Liquid vacuum pump": "液环真空泵",
	"Rated current": "额定电流",
	"Rated rpm": "额定转速",
	"Running time": "设备运行总时长",
	"Days": "天",
	"Hours": "小时",
	"Torque": "扭矩",
	"NASH Store": "NASH在线商城",
	"Energy saving overview": "节能降碳数据总览",
	"Total annual energy unit": "机组年度节能总收益",
	"UN power saving income": "机组年度节电收益",
	"UN CO2 emission benefit": "机组年度CO₂排放收益",
	"Predictive maint saves benefits": "预测性维护节省收益",
	"Total power saving": "节电总量",
	"Reduced CO2 emissions": "减少CO₂排放量",
	"CO2 price today": "今日CO₂价格",
	"Electricity price today": "今日电价",
	"Coal price today": "今日煤价",
	"UN energy saving analysis": "机组节能分析",
	"UN energy saving chart": "机组30天节能图表",
	"Savings on electricity 30d": "过去30天节约电费",
	"CO2 emissions reduced 30d": "过去30天减少CO₂排放",
	"Electricity bill 30d": "过去30天总电费",
	"CO2 emissions 30d": "过去30天产生CO₂排放",
	"Monthly electricity": "月用电分析",
	"UN monitoring and analysis": "机组实时能耗监控分析",
	"Operating status": "运行状态",
	"Energy saving": "节能",
	"SA energy saving benefit": "系统年度节能总收益",
	"SA coal saving income": "系统年度节煤收益",
	"SA CO2 emission benefit": "系统年度CO₂排放收益",
	"Power before renovation": "改造前电耗",
	"Power after renovation": "改造后电耗",
	"Actual power": "实际电耗",
	"Rated power": "额定电耗",
	"Roots pump motor rated power": "罗茨泵电机额定功率",
	"Screw pump motor rated power": "螺杆泵电机额定功率",
	"Total coal saving": "节煤总量",
	"system_back_pressure_improves_cs": "系统背压改善节煤收益",
	"unit_electricity_consumption_improvement_and_coal_savings_benefits":"机组电耗改善节煤收益",
	"Unit frequency conversion CS income": "机组变频节煤收益",
	"Unit Load Tracking CS Benefit": "机组负荷跟踪节煤收益",
	"Normal_status": "正常运行",
	"Caution_status": "低风险运行",
	"Warning_status": "高风险运行",
	"Next Service Plan": "下次保养计划",
	"Level-2": "二级保养",
	"Maintenance Items": "保养提醒",
	"Sustainability Analysis": "节能降碳",
	"Risk Assessment Model": "风险评估模型",
	"Pump Stuck Warning": "卡泵高风险预警",
	"Pump Stuck Caution": "卡泵低风险预警",
	"362 Days 20 Hours": "362天20小时",
	"Last Service Record": "上次保养记录",
	"Level-1": "一级保养",
	"Good_status": "优良",
	"Enabled_status": "开启",
	"Smart O&M Model": "智能运维模式",
	"Vacuum Running Status": "真空状态",
	"Cavitation Analysis": "汽蚀分析",
	"Replace coupling resilient blocks": "更换联轴器弹性块",
	"Change motor lube oil": "更换电机润滑脂",
	"Mechanical seal inspection": "检查机械密封",
	"Pump surface inspection": "检查螺杆外表面和泵体内表面",
	"Synchronous gears surface inspection": "检查同步齿轮表面",
	"Pump inlet filter inspection": "检查清理入口滤网",
	"Replace pump lube oil": "更换真空泵前端盖润滑油和后端盖润滑脂",
	"Replace motor bearing": "更换轴承",
	"Symptoms": "现象表征",
	"Screw pump torque abnormal": "螺杆泵扭矩数据异常波动，进入低风险区间",
	"Screw pump motor current abnormal": "螺杆泵电机电流数据异常，进入低风险区间",
	"Root cause analysis": "原因分析",
	"Startup warmingup process missing": "开机暖泵程序未运行",
	"Shutdown clearning and nitrogen purge replacement process missing": "关机清洗和氮气吹扫置换未进行",
	"Low cooling water temperature cause crystallistation": "冷却水温度过低产生结晶",
	"Foreign object entry": "异物进入",
	"Advice": "操作建议",
	"Check for rattling": "检查是否有异响",
	"Lowering running speed": "降低转速",
	"Open solvent cleaning": "打开溶剂清洗",
	"Increasing cooling water temperature": "提高冷却水温度",
	"Roots pump motor current abnormal": "螺杆泵电机电流有变化，不在允许范围内。",
	"Motor current abnormal": "电机电流有变化，不在允许范围内。",
	"Roots pump motor pump overheating": "螺杆泵泵体过热，进口气体温度过高。",
	"Motor pump overheating": "泵体过热，进口气体温度过高。",
	"Roots pump motor vibration abnormal": "螺杆泵电机上X向振动数值进入异常状态。",
	"Motor vibration abnormal": "电机上X向振动数值进入异常状态。",
	"Machine Cleaning": "清洗",
	"Warmingup": "暖机",
	"Maintenance": "保养维护",
	"Stream media": "流体介质",
	"Roots pump inlet temperature": "罗茨泵入口温度",
	"Confirm whether it is back to normal, otherwise stop and perform endoscopy": "确认是否恢复正常,否则停机并进行内窥镜检查",
	"Torque  of screw pump is in the high-risk zone": "螺杆泵扭矩进入高风险区间",
	"The motor current  of screw pump is in the high-risk zone": "螺杆泵电机电流进入高风险区间",
	"The outlet temperature  of screw pump is in the high-risk zone": "罗茨泵出口温度进入高风险区间",
	"The outlet pressure   of screw pump is in the high-risk zone": "罗茨泵出口压力进入高风险区间",
	"Gears or bearings Damaged": "齿轮或轴承损坏",
	"Not enough lubrication": "润滑不够",
	"REC. Change greases": "建议更换润滑脂",
	"Overheating of the pump body": "泵体过热",
	"High temperature of inlet gases": "进口气体温度过高",
	"Lower inlet gas temperature": "降低进口气体温度",
	"Cooling water flow of the Roots pump is not less than the minimum flow": "罗茨泵冷却水流量不低于最小流量要求。",
	"Cooling water flow of the pump is not less than the minimum flow": "冷却水流量不低于最小流量要求。",
	"Inlet temperature-sim": "系统入口温度",
	"Inlet Flow-sim": "系统入口流量",
	"Motor Current of Roots Pump": "罗茨泵电机电流",
	"Inlet Flow Rate of Screw Pump": "螺杆泵入口流量",
	"Inlet Pressure of Screw Pump": "螺杆泵入口压力",
	"Motor Current of Screw Pump": "螺杆泵电机电流",
	"rpm of Motor of Roots Pump": "罗茨泵电机转速",
	"Motor X-axis Vibration of Roots Pump": "罗茨泵电机X轴振动",
	"X-axis Vibration": "X轴振动",
	"Motor X-axis Vibration of Screw Pump": "螺杆泵电机X轴振动",
	"Motor rpm of Screw Pump": "螺杆泵电机转速",
	"Instrument Calibration": "仪表校验",
	"Analysis of Online": "在线分析",
	"Parts Purchase": "备件购买",
	"Pump seizure": "卡泵",
	"Motor loads": "电机负载",
	"Pump Noises": "泵体异响",
	"Select Part No": "选择位号",
	"Analysing": "分析中",
	"Finished": "分析完成",
	"Online Service": "在线服务",
	"Unit Real-time Operation Data": "机组运行曲线",
	"Pump Bearing Vibration": "真空泵轴承振动 (mm/s)",
	"Drive Side": "驱动端",
	"Non-drive Side": "非驱动端",
	"Motor Overloaded": "电机超功率",
	"Motor Overloaded Caution": "电机超功率低风险",
	"Motor Overloaded Warning": "电机超功率高风险",
	"Motor high vibration detected": "设备振动噪音进入低风险区间",
	"Troubleshooting according to the above root causes.If the motor viration continues to increase it is recommended to switch to the backup unit": "按照以上原因分析进行故障排查，如果振动噪音持续增强建议切换备机",
	"Bearing failure": "轴承故障",
	"Exhaust valve plate dislodged": "排气阀片脱落",
	"Foreign objects in pump body": "有异物进入泵腔",
	"Loose ground bolts": "地脚螺栓松动",
	"Pump fouling": "泵内结垢严重引起部件的摩擦",
	"Cavitation": "汽蚀的原因",
	"Coupling alignment": "联轴器不对中",
	"Steam temperature": "对应饱和蒸汽温度",
	"V Inlet pressure": "真空泵吸气压力",
	"Cold air": "空气过冷",
	"Motor side bearing viberation": "驱动端轴承振动",
	"Pump side bearing viberation": "非驱动端轴承振动",
	"Enivornment temperature": "环境温度",
	"Env Pressure": "大气压",
	"Air Subcooling": "空气过冷度",
	"Mixed Air Temperature": "混合气体温度",
	"Working Flow Temperature": "工作液温度",
	"Steam temperature-v": "对应饱和蒸汽温度",
	"V-Inlet pressure": "真空泵吸气压力",
	"Cavitation Warning": "汽蚀风险",
	"Cavitation Caution": "汽蚀低风险",
	"Pump pressure difference is too high": "端差数据进入高风险区间",
	"Pump pressure difference is too low": "端差数据进入低风险区间",
	"Heat exchanger tubes blocked": "换热器管堵塞",
	"Low working fluid flow": "工作液流量低",
	"Low separator level": "分离器液位低",
	"Inlet filter blocked": "入口过滤网堵塞",
	"Inlet check valve blocked": "入口止回阀卡塞",
	"Troubleshooting according to above listed root causes, if cavitation remain it is recommended to switch to the back machine": "按照以上原因分析进行故障排查，如果汽蚀持续高风险状态建议切换备机运行",
	"Check if the heat exchanger tubes blocked, if working fluid flow rate is low, check orifice plate blocked": "检查换热器管是否堵塞，通过四个口温度曲线判断冷却水流量是否正常",
	"Check if inlet filter is blocked, if the separator level is also low, you need to check the water fill solenoid valve": "检查入口过滤网是否堵塞，如果也为偏低，需要检查工作液管道上的孔板是否堵塞。",
	"Water Consumption Analysis": "水耗分析",
	"Water Consumption Caution": "水耗低风险",
	"Water Consumption Warning": "水耗高风险",
	"High bearing vibration": "设备轴承振动噪声进入低风险区间",
	"Check for coupling alignment": "检查连轴器对中",
	"Check for pump cavitation": "检查汽蚀的原因",
	"Check for fouling in pumps": "确认泵内结垢严重引起的部件摩擦",
	"Check for foreign object in pump": "检查是否有异物进入泵腔",
	"Check for dislodged exhaust valves": "检查是否排气阀片脱落",
	"Filling bearing greases": "加注轴承润滑脂",
	"Change bearing greases": "更换轴真空泵承润滑脂",
	"Filling motor bearing greases": "加注电机轴承润滑脂",
	"Change motor bearing greases": "更换电机轴承润滑脂",
	"Filler replacement": "加注填料",
	"Replace coupling diaphragm": "更换连轴器膜片",
	"Cleaning heat exchanger": "清洗热交换器",
	"Replace bearing": "更换真空泵轴承",
	"Off": "全关",
	"Emergency stop": "急停",
	"Normal": "正常",
	"High":"高",
	"Low":"低",
	"Running Current": "运行电流",
	"Cooling System": "冷却系统",
	"1# vacuum pump status": "1#液环真空泵运行/停止",
	"1# vacuum pump ready/failure": "1#液环真空泵就绪/故障",
	"1# Vacuum pump inlet valve": "1#真空泵入口阀",
	"2# vacuum pump status": "2#液环真空泵运行/停止",
	"2# vacuum pump ready/failure": "2#液环真空泵就绪/故障",
	"2# Vacuum pump inlet valve": "2#真空泵入口阀",
	"Centrifugal Pumps": "离心泵",
	"Centrifugal pump status": "离心泵运行/停止",
	// "Centrifugal pump ready/failure":"离心泵就绪/故障",
	"running": "运行",
	"open": "开",
	"close": "关",
	"failure": "故障",
	"stop": "停止",
	"ready": "就绪",
	// "Unit Real-time Operation Data":"机组运行曲线",
	"Unit temperature and pressure data": "机组温度和压力曲线",
	"Suction pressure": "吸气压力",
	// "Working fluid temperature":"工作液温度",
	"Real-time Current": "机组电流曲线",
	"Low level switch with continuous alarm for 2 minutes": "低液位开关持续报警2分钟",
	"Faulty water fill valve": "补水阀故障",
	"Liquid level switch failure": "液位开关故障",
	"Vacuum Pump Leakage": "真空泵泄漏",
	"Water tank leakage": "水箱泄漏",
	"Water supply issues": "水源问题",
	"Check if the water fill valve can be opened normally": "检查补水阀是否能正常打开",
	"Checking the liquid level switch": "检查液位开关",
	"Customise_Dashboard": "自定义右侧数据板块展示内容",
	"Intelligent unit": "智能机组",
	"Motor current enters the high-risk zone": "电机电流进入高风险区间",
	"Refer to the motor manual": "参照电机说明书",
	"Refer to the motor manual, if the power exceeds 10% of the rated power, it is recommended to switch the backup machine": "参照电机说明书,如功率超过额定功率10%,建议切换备机",
	"Vibration noise": "振动噪音",
	"High risk early warning of noise": "振动噪音高风险预警",
	"Low risk early warning of noise": "振动噪音低风险预警",
	"High risk early warning of bearing": "轴承温度高风险预警",
	"Low risk early warning of bearing": "轴承温度低风险预警",
	"High equipment bearing temperature enters high risk zone": "设备轴承温度高进入高风险区间",
	"Too much or too little grease": "润滑脂过多或过少",
	"Degradation of grease": "润滑脂变质",
	"Bearing damage": "轴承损坏",
	"Coupling or belt alignment problems": "联轴器或皮带对中问题",
	"Improper bearing installation": "轴承安装不当",
	"Troubleshooting according to the above reasons, if the temperature is higher than 100 °C, it is recommended to switch the backup machine": "按照以上原因分析进行故障排查,如温度高于100 °C建议切换备机",
	"Status": "运行/停止",
	"Remote / Local": "远控/就地",
	"Remote": "远控",
	"Ready / Failure": "就绪/故障",
	"Vacuum Pumps": "真空泵",
	"Inlet valve": "入口阀",
	"Open": "全开",
	"Motor": "电机",
	"Running": "正常运行",
	"Motor MCC": "电机MCC",
	"Circulation Pump": "工作液循环泵",
	"Heat Exchangers": "换热器",
	"Working Fluid Inlet Temperature": "工作液入口温度",
	"Working Fluid Outlet Temperature": "工作液出口温度",
	"Cooling Water Inlet Temperature": "冷却水入口温度",
	"Cooling Water Outlet Temperature": "冷却水出口温度",
	"Vacuum Pump Motor": "真空泵电机",
	"Currentting": "运行电流",
	"Rotation Speed Realy": "实际转速",
	"Winding Temperature U": "绕组温度U",
	"Winding Temperature V": "绕组温度V",
	"Winding Temperature W": "绕组温度W",
	"Drive Bearing Temperature": "驱动端轴承温度",
	"Non-driven Bearing Temperature": "非驱动端轴承温度",
	"Inlet Prevalence Pressure": "入口阀前压力",
	"Inlet Post-valve Pressure": "入口阀后压力",
	"Drive Bearing Vibration": "驱动端轴承振动",
	"Non-driven Bearing Vibration": "非驱动端轴承振动",
	"Unit Name": "机组名称",
	"Affected sensor": "受影响传感器",
	"status": "状态",
	"Update time": "更新时间",
	"Pump Body": "泵体",
	"Outlet pressure": "出口压力",
	"The x-axis vibration of the motor has entered the intelligent alarm state. At that time, the sensor reading was 4.3. At that time, the dynamic threshold was 2.0 – 4.1 mm/s": "电机x轴向振动进入了智能警报状态。当时传感器读数 4.3.，当时动态阈值 2.0 – 4.1mm/s",
	"The motor is overloaded, and the back pressure at the exhaust port increases": "电机过载，排气口背压增大",
	"The cooling water flow exceeds the specification": "冷却水流量超出说明书标准",
	"The X-direction vibration value of the motor enters into an abnormal state": "电机上X向振动数值进入异常状态",
	"Resolved": "已解决",
	"Predictive maintenance alarm": "预测性维护警报",
	"High bearing temperature or abnormal sound": "轴承温度高或有异音",
	"Motor overpower cause": "电机超功率原因",
	"Inspection steps": "检查步骤",
	"Coupling or belt misalignment": "联轴器或皮带不对中",
	"The exhaust valve plate is damaged and falls off": "排气阀片损坏，脱落",
	"Poor exhaust and high back pressure": "排气不畅，背压过高",
	"Severe scaling in the pump causes internal friction of the pump": "泵内结垢严重，引起泵内部摩擦",
	"Packing is too tight": "盘根过紧",
	"Excessive water content in suction": "吸气含水量过大",
	"Image": "图片",
	"Motor selection document": "电机选择文件",
	"File": "文档",
	"Cancel": "取消",
	"Save": "保存",
	"expert_view": "专家视角",
	"intelligent_diagnose": "气蚀诊断",
	"audit_report": "体检报告",
	"energy_consumption_analysis":"能耗分析",
	"energy_analysis": "节能降碳/降本增效分析",
	"device_lifecycle": "全生命周期",
	"online_store": "NASH在线商城",
	"all_device": "所有设备",
	"digital_twin": "数字孪生",
	"industry": "应用行业",
	"customer_name": "客户名称",
	"cooling_water_temp": "冷却水温度",
	"suction_pressure": "吸气压力",
	"rotation_speed": "叶轮转速",
	"gas_displacement": "排气量",
	"heat_exchange_ttd": "热交换器两侧端差",
	"power_consumption": "轴功率",
	"Apply": '应用',
	设备数据: '设备数据',
	'建议进行IOT升级':'建议进行IOT升级',
	"设备事件":"设备事件",
	"设备工单":"设备工单",
	month: {
		jan: '1月',
		feb: '2月',
		mar: '3月',
		apr: '4月',
		may: '5月',
		jun: '6月',
		jul: '7月',
		aug: '8月',
		sep: '9月',
		oct: '10月',
		nov: '11月',
		dec: '12月'
	},

	overview_dynamic: {
		新增: '新增',
		报废: '报废',
		在用: '在用',
		设备数量统计: '设备数量统计',
		IoT状态统计: 'IoT状态统计',
		//work order type
		设备维修: '设备维修',
		点巡检: '点巡检',
		安装调试: '安装调试',
		故障排查: '故障排查',
		设备保养: '设备保养',
		工单负荷: '工单负荷',
		//商机丢失原因类型
		现场无此设备: 'Device not Alive',
		客户自行维护: 'Customer Self-Maintenance',
		第三方: 'by Third Party',
		零部件供应商: 'by Vendor',
		竞争对手: 'by Competitor',
		其它: 'Others',
		//设备类型
		device_type_dict: { '液环泵': '液环泵', '罗茨泵': '罗茨泵', '螺杆泵': '螺杆泵', '风机': '风机', '干泵': '干泵', '其他': '其他' },

		//行业类型 “|” 在 vue-i18n 中属于特殊字符（还有{、}、@ 、$），如果要使用的话必须通过插值表达式 {'|'}，比如：“多个参数请使用{'|'}连接”。
		industy_dict: { "制药": "制药", "石化": "石化", "造纸": "造纸", "化工": "化工", "通用": "通用", "油气": "油气", "设备": "设备", "钢铁": "钢铁", "电力": "电力", "污水": "污水", "矿业": "矿业", "食品": "食品", "造纸配套户": "造纸配套户", "电子": "电子", "核电": "核电", "啤酒": "啤酒", "纤维": "纤维", "医疗": "医疗", "有机硅": "有机硅", "煤化工": "煤化工", "煤炭": "煤炭", "氨纶": "氨纶", "烟草": "烟草", "配套": "配套", "煤矿": "煤矿", "制糖": "制糖", "酵母": "酵母", "粮油": "粮油", "医药": "医药", "轮胎": "轮胎", "炭黑": "炭黑", "铝业": "铝业", "市政": "市政", "铸造": "铸造", "曝气": "曝气", "垃圾填埋": "垃圾填埋", "中央真空": "中央真空", "空气助燃": "空气助燃", "总包": "总包", "蒸发": "蒸发", "家禽内脏剔除": "家禽内脏剔除", "浮选": "浮选", "烟气脱硫": "烟气脱硫", "干燥": "干燥", "包装": "包装", "塑料挤出": "塑料挤出", "气力输送": "气力输送", "食物": "食物", "陶瓷": "陶瓷", "分销商": "分销商", "过滤": "过滤", "OEM配套": "OEM配套", "金属生产": "金属生产", "采矿": "采矿", "贸易公司": "贸易公司", "水处理": "水处理", "OEM制造商": "OEM制造商", "造纸厂": "压区脱水", "纸浆厂": "纸浆厂", "卫生纸": "卫生纸", "箱板纸": "箱板纸", "原纸加工": "原纸加工", "辅助苛化器": "辅助苛化器", "无防布": "无纺布", "生物气处理": "生物气处理", "火炬气回收": "火炬气回收", "Wais火炬气回收": "Wais火炬气回收", "碳氢化合物": "碳氢化合物", "液化天然气": "液化天然气", "VRU装卸": "VRU装卸", "废气": "废气", "VRU储罐": "VRU储罐", "VCG": "VCG", "VDU": "VDU", "VOC挥发性有机物": " VOC挥发性有机物", "油气其他": "油气其他", "污水处理厂市政曝气": "污水处理厂市政曝气", "城市污水处理": "城市污水处理", "污水处理厂工业曝气": "污水处理厂工业曝气", "污水处理厂工业消化池": "污水处理厂工业消化池", "凝汽器抽真空": "凝汽器抽真空", "凝汽器启动抽空": "凝汽器启动抽空", "飞灰输送": "飞灰输送", "地热发电": "地热发电 ", "动力润滑油脱气": "动力润滑油脱气", "水室真空泵": "水室真空泵", "汽轮机": "汽轮机", "填埋气压缩": "填埋气压缩", "氯气": "氯气", "VCM": "VCM ", "TDI/MDI/HDI": "TDI/MDI/HDI", "MMA": "MMA ", "PC": "PC", "PTMEG": "PTMEG", "甲醇": "甲醇", "农药|蒸馏": "农药{'|'}蒸馏", "农用化学品|干燥": "农用化学品{'|'}干燥", "农用化学品|反应器真空": "农用化学品{'|'}反应器真空", "农用化学品|脱气": "农用化学品{'|'}脱气", "农药|溶剂回收": "农药{'|'}溶剂回收", "农药|结晶": "农药{'|'}结晶", "农药|过滤": "农药{'|'}过滤", "农药|蒸发": "农药{'|'}蒸发", "农药|冷冻干燥": "农药{'|'}冷冻干燥", "特色香精蒸馏": "特色香精蒸馏", "香精和香料|干燥": "香精和香料{'|'}干燥", "香精香料反应器真空": "香精香料反应器真空", "香料|脱气": "香料{'|'}脱气", "特种香精香料溶剂回收": "特种香精香料溶剂回收", "香料|结晶": "香料{'|'}结晶", "香精和香料|过滤": "香精和香料{'|'}过滤", "香料|蒸发": "香料{'|'}蒸发", "香精香料|冷冻干燥": "香精香料{'|'}冷冻干燥", "塑料、合成橡胶、树脂、纤维|蒸馏": "塑料、合成橡胶、树脂、纤维{'|'}蒸馏", "塑料、合成橡胶、树脂、纤维|干燥": "塑料、合成橡胶、树脂、纤维{'|'}干燥", "塑料、合成橡胶、树脂、纤维|反应器真空": "塑料、合成橡胶、树脂、纤维{'|'}反应器真空", "塑料、合成橡胶、树脂、纤维|脱气": "塑料、合成橡胶、树脂、纤维{'|'}脱气", "塑料、合成橡胶、树脂、纤维|溶剂回收": "塑料、合成橡胶、树脂、纤维{'|'}溶剂回收", "塑料、合成橡胶、树脂、纤维|结晶": "塑料、合成橡胶、树脂、纤维{'|'}结晶", "塑料、合成橡胶、树脂、纤维|过滤": "塑料、合成橡胶、树脂、纤维 {'|'} 过滤", "塑料、合成橡胶、树脂、纤维|蒸发": "塑料、合成橡胶、树脂、纤维 {'|'} 蒸发", "塑料、合成橡胶、树脂、纤维|冷冻干燥": "塑料、合成橡胶、树脂、纤维 {'|'} 冷冻干燥", "粘合剂和密封剂|蒸馏": "粘合剂和密封剂{'|'}蒸馏", "粘合剂和密封剂|干燥": "粘合剂和密封剂{'|'}干燥", "粘合剂和密封剂|反应器真空": "粘合剂和密封剂{'|'}反应器真空", "粘合剂和密封剂|脱气": "粘合剂和密封剂{'|'}脱气", "粘合剂和密封剂|溶剂回收": "粘合剂和密封剂{'|'}溶剂回收", "粘合剂和密封剂|结晶": "粘合剂和密封剂{'|'}结晶", "粘合剂和密封剂|过滤": "粘合剂和密封剂{'|'}过滤", "粘合剂和密封剂|蒸发": "粘合剂和密封剂{'|'}蒸发", "粘合剂和密封剂|冷冻干燥": "粘合剂和密封剂{'|'}冷冻干燥", "油漆、清漆、清漆|蒸馏": "油漆、清漆、清漆{'|'}蒸馏", "油漆、清漆、清漆|干燥": "油漆、清漆、清漆{'|'}干燥", "涂料、清漆、清漆|反应器真空": "涂料、清漆、清漆{'|'}反应器真空", "油漆、清漆、清漆|脱气": "油漆、清漆、清漆{'|'}脱气", "油漆、清漆、清漆|溶剂回收": "油漆、清漆、清漆{'|'}溶剂回收", "色漆、清漆、清漆|结晶": "色漆、清漆、清漆{'|'}结晶", "油漆、清漆、清漆|过滤": "油漆、清漆、清漆{'|'}过滤", "油漆、清漆、清漆|蒸发": "油漆、清漆、清漆{'|'}蒸发", "油漆、清漆、清漆|冷冻干燥": "油漆、清漆、清漆{'|'}冷冻干燥", "工业气体|氢气": "工业气体{'|'}氢气", "工业气体|二氧化碳": "工业气体{'|'}二氧化碳", "其他特种化学品及中间体|蒸馏": "其他特种化学品及中间体{'|'}蒸馏", "其他专业化学品和中间体|干燥": "其他专业化学品和中间体{'|'}干燥", "其他专业化学品和中间体|反应器真空": "其他专业化学品和中间体{'|'}反应器真空", "其他特种化学品及中间体|脱气": "其他特种化学品及中间体{'|'}脱气", "其他特种化学品及中间体|溶剂回收": "其他特种化学品及中间体{'|'}溶剂回收", "其他特种化学品及中间体|结晶": "其他特种化学品及中间体{'|'}结晶", "其他特种化学品和中间体|过滤": "其他特种化学品和中间体{'|'}过滤", "其他特种化学品及中间体|蒸发": "其他特种化学品及中间体{'|'}蒸发", "其他专业化学品和中间体|冷冻干燥": "其他专业化学品和中间体{'|'}冷冻干燥", "制药蒸馏": "制药蒸馏", "药品干燥": "药品干燥", "制药|干燥": "制药{'|'}干燥", "制药反应器真空": "制药反应器真空", "制药|脱气": "制药{'|'}脱气", "医药溶剂回收": "医药溶剂回收", "药物结晶": "药物结晶", "制药过滤": "制药过滤", "药物蒸发": "药物蒸发", "冷冻干燥": "冷冻干燥", "臭氧": "臭氧", "生物燃料": "生物燃料", "Carbon black":"炭黑","General":"通用" },

		//工单类型
		order_type_dict: { "设备维修": "设备维修", "设备保养": "设备保养", "安装调试": "安装调试", "故障排除": "故障排除" },

		//工单状态
		order_status_dict: { "已完成": "已完成", "已取消": "已取消", "施工中": "施工中", "待施工": "待施工", "待转派": "待转派", "待确认": "待确认", "待派工": "待派工" },

		//报告类型
		report_dict: { "服务报告": "服务报告", "回访报告": "回访报告", "开箱验收报告": "开箱验收报告", "现场培训": "现场培训", "维修报告": "维修报告", "安装调试报告": "安装调试报告" },

		//保养类型
		service_type_dict: { "日常保养": "日常保养", "一级保养": "一级保养", "二级保养": "二级保养", "返厂大修": "返厂大修" },

		//事件类型
		event_type_dict: { "提醒": "提醒", "错误": "错误", "警告": "警告" },

		//智能运维模式
		smart_maintenance_dict: { "开启": "ON", "关闭": "OFF" },

		//IoT测点名称、事件信息以及保养详情没有翻译

		"在保": '在保',
		"脱保": '脱保',
		"离线": '离线',
		请进行IoT升级: "请进行IoT升级",
		主页: '主页'

	},

	//数据统计页面上的静态信息（非接口返回）
	overview_static: {
		现场无此设备: '现场无此设备',
		预测偏差: '预测偏差',
		竞争对手: '竞争对手',
		供应商直供: '供应商直供',
		找第三方: '找第三方',
		客户自行维保: '客户自行维保',
		//标题
		nash_intelligent_iiot_after_market_management_system:'智能化运维管理平台',
		//Menu
		overview: '云图',
		dashboard: '总览',
		business_opportunity: '商机',
		work_order: '工单',
		device: '设备',

		//通用翻译
		common: {
			industry: '行业',
			time: '时间',
			to: '至', //时间组件的from to
			work_order: '工单',
			customer: '客户',
			device: '设备',
			amount: '总量',
			台: '台',//英文没有量词，所以不翻译
			单: '单',
			分: '分',
			个: '个',
			星期一: '星期一',
			星期二: '星期二',
			星期三: '星期三',
			星期四: '星期四',
			星期五: '星期五',
			星期六: '星期六',
			星期日: '星期日',
			device_types: {
				liquid_ring_vacuum_pump: '液环真空泵',
				roots: '罗茨泵',
				screw_pump: '螺杆泵',
				air_blower: '风机',
			},

			details: '查看详情',
		},

		//总览统计界面(左右上下)
		dahsboard_page: {

			//行业统计
			industry_overview: '行业统计',

			//设备状态
			device_status: '设备状态',
			non_iot_device: '非IoT设备',
			iot_reday: 'IoT Ready',
			iot_connected: 'IoT Connected',
			other_status: '其它状态',//设备其他状态，非iot
			barcode_attached: '已绑定',//已绑定
			barcode_unattached: '未绑定',
			wasted: '报废',

			//产品类型
			device_distribution_on_category: '产品类型',

			//服务与商机
			business_opportunity: '服务与商机',
			bo_varivance_rate: '商机丢失率',
			total_bo: '商机总量',
			hit: '已完成',//已完成
			to_be_converted: '待转化',
			converted: '已转化',
			among_delayed: '延期量',

			//商机丢失原因
			varivace_reason: '商机丢失原因',
			总计延期量: '总计延期量',
			//工单统计
			work_order: '工单统计',
			responsed_on_time: '及时确认率',//及时确认率
			closed_on_time: '及时关闭率',//及时关闭率
			done: '完成率',
			customer_satisfaction: '满意度',//满意度
			customer_satisfaction_score: '客户满意度得分',
			//弹窗信息
			进行中工单总量: '进行中工单总量',
			map_area: {

				//齿轮图标
				barcode_attached: '已绑定',//已绑定
				barcode_unattached: '未绑定',
				wasted: '报废',
				customer_amount: '客户总量',

				healthy: '健康',
				abnormal: '异常',
				risky: '危险',
				non_iot_device: '非IoT设备',
				iot_reday: 'IoT Ready',
				iot_connected: 'IoT Connected',

				//服务图标
				order_amount: '工单总量',
				order_in_progress: '进行中工单',
				order_completed: '完成工单总量',
				bo_amount: '商机总量',
				workload: '工作负荷',
				设备数量: '设备数量',
				服务数量: '服务数量'
			}
		},

		//工单统计界面（左右上下）
		work_order_page: {

			//第一行
			work_order_amount: '总计',
			order_in_progress: '正在进行中工单',
			compared_to_last_year: '较去年',
			order_in_this_month: '本月工单',
			compared_to_last_month: '较上月',
			month_by_month: '月环比',
			month_on_month: '月同比',
			completed_in_this_month: '本月已完成工单',

			//第二行
			order_status: '工单状态统计',
			order_trend: '状态分析',//状态分析
			new_orders: '新增数量',
			complete_orders: '完成数量',
			incomplete_order: '所有未完成数量',
			unit: '单',//单
			report_distribution_on_category: '报告类型',

			//第三行
			order_feedback: '工单反馈情况',
			ave_response_speed: '平均响应时间',
			response_to_arr: '平均到达时间',
			ave_fix: '平均修复时间',
			customer_satisfaction_score: '客户满意度得分',
			responsed_on_time: '及时确认率',//及时确认率
			closed_on_time: '及时关闭率',//及时关闭率
			done: '完成率',
			customer_satisfaction: '满意度',//满意度
			order_distribution_on_industry: '工单行业统计',
			order_amount: '工单数量',
			单: '单'//y轴单位
		},

		//设备统计界面（左右上下）
		device_overview_page: {

			//第一行
			device_amount: '总计',
			台: '台',
			compared_to_last_year: '较去年',
			increase_rate: '年增长率',
			waste_reate: '年报废率',
			iot_reday: 'IoT Ready',
			iot_connected: 'IoT Connected',
			占所有设备量比: '占所有设备量比',
			//第二行
			device_distribution_on_industry: '应用行业型号统计',
			greater_than: '大于',
			less_than: '小于',
			device_category: '设备类型统计',

			//第三行
			main_category_distribtion_on_industry: '应用行业产品分类统计',
			new_device: '装机量',
			台y: '台',
			barcode_attached: '已绑定',//已绑定
			barcode_unattached: '未绑定',
			unattached_among_all: '所有未绑定设备比例'
		},

		//客户统计界面（左右）
		customer_page: {
			serial_numner: '序列号',
			status: '健康状态',
			service_plan: '保养计划',
			next_service_time: '下次保养时间',
			next_service: '下次保养名称',
			delayed: '已延期',//23 days delayed
			天: '天',
			service_status: '保养状态',
			warranty_valid_until: '质保到期时间',
			extend_your_warranty: '续保入口',
			device_events: '设备事件',
			iot_status: '设备整体IoT状态',
			health_status: '设备整体健康状态',

			online: '在线',
			offline: '离线',
			healthy: '健康',
			abnormal: '异常',
			risky: '危险',
			unknown:'未知',
			energy_consumption_trend: '能耗趋势分析',
			device_consumption: '实际电耗',
			benchmark: '行业均值'//行业均值
		},

		//单个设备界面
		device_page: {

			//设备信息
			device_name: '名称',
			device_type: '设备类型',
			device_serial_number: '序列号',
			customer_name: '客户名称',
			industry: '应用行业',

			//设备保养计划
			service_plan: '设备保养计划',
			next_service_time: '下次保养时间',
			next_service: '下次保养名称',
			delayed: '已延期',//23 days delayed
			天: '天',
			service_detail: '保养提醒',

			//中部
			vacuum_status: '真空状态',
			status_v: '优良',//演示用
			smart_maintenance: '智能运维模式',
			add_more_data: '添加数据',

			//测点数据
			realtime_data: '实时数据',
			current: '机组运行电流',
			liquid_temp: '工作液温度',
			customise_measurements_component: '自定义右侧数据板块展示内容',
			measurements: '测点数据',

			//底部按钮
			expert_view: '专家视角',
			intelligent_diagnose: '智能诊断',
			audit_report: '体检报告',
			energy_analysis: '节能降碳分析xx?',
			device_lifecycle: '全生命周期',
			online_store: 'NASH在线商城',
			//智能诊断
			power_consumption: '轴功率',
			cooling_water_temp: '冷却水温度',
			suction_pressure: '吸气压力',
			rotation_speed: '叶轮转速',
			gas_displacement: '排气量',
			heat_exchange_ttd: '热交换器两侧端差',
			//机组数据
			iot_info: '机组数据',
			//设备报警
			device_event: '设备事件'
		}
	},

	base: {
		delete: '删除',
		delete_success: '删除成功!',
		delete_failed: '删除失败',
		delete_failed_please_try_again: '上传失败，请重试!',
		upload: '上传',
		upload_success: '上传成功!',
		submit: '提交',
		submit_success: '提交成功',
		submit_failed: '提交失败',
		delete_alert_title: "确定删除？",
		delete_alert_info: "此操作不可撤回！",
		delete_alert_completed: '已删除',
		ok: '确定',
		done: '确定',
		cancel: '取消',
		refuse:'拒绝',
		confirm: '确认',
		pass: '通过',
		edit: '编辑',
		permission: '权限',
		has_no_permission: '没有操作权限',
		prompt: '提示',
		error_request: '请求错误',
		add: '添加',
		add_success: '添加成功',
		add_failed: '添加失败',
		operation: '操作',
		operate_success: '操作成功',
		operate_failed: '操作失败',
		modify: '修改',
		modified_successfully: '修改成功',
		modified_failed: '修改失败',
		refresh: '刷新',
		'detail': '详情',
		"Confirm to perform this operation?": "确定执行此操作？",
		"filter": "筛选",
		"reset": "重置",
		"required": "必填",
		"select-all": "全选",
		"export": "导出",
		"select-date": "选择日期",
		"an-error-occurred": "出现错误",
		"no-data": "暂无数据",
		save: "保存",
		'saving': '保存中...',
		"file_export_failed": "文件导出失败，请重试！",
		"search_device_name": '搜索设备名称',
		"unmatched_data": '无匹配数据',
		'time': '次',
		'type': '类型:',
		'product': '产品:',
		'last_modification_date': '上次修改日期:',
		'create_date': '创建日期:',
		'connection_status': '连接状态',
		'attribute': '属性',
		'gauge_point': '测点',
		'associated': '关联设备',
		'data_bank': '资料库',
		'tag': '标签',
		'no_attribute': '无属性',
		'add_attribute': '添加属性',
		'no_gauge_point': '无测点',
		'no_associated': '无关联设备',
		'no_tag': '无标签',
		'no_tending': '无维护保养项',
		'picture': '图片',
		'video': '视频',
		'document': '文档',
		'create_qrcode': '生成二维码',
		'data_type': '数据类型',
		'select_customer': '请选择客户',
		'cancel_connect': '取消关联',
		'sure_cancel_connect': '您确定要取消关联吗？',
		'add_concact_device': '添加关联设备',
		'input_tag_name': '请输入标签名称',
		'input_tag_value': '请输入标签值',
		'add_tag': '添加标签',
		'FilePictureData': '文件图片资料',
		'save_success': '保存成功',
		'loading': '加载中...',
		'update': '更新',
		'ModifyFailedPleaseTryAgain': '修改失败，请重试！',
		'AddGroup': '添加组',
		'exporting': '导出中...',
		'to': '至',
		'name': '名称',
		'import_pump': '进口泵',
		'iot_ready': 'IOT Ready',
		'yes': '是',
		'no': '否',
		'duplicate_name':'该账户名已存在，请重新输入。',
	},
	page: {
		"return-visit-remarks":"回访备注",
		"service-ratings":"服务评分",
		"service-provider": "服务商",
		"no-notification": "暂无通知消息",
		"download-failed-please-try-again": "下载失败，请重试!",
		"service-company": "代理商",
		"engineer": "工程师",
		"complete-time": "完成时间",
		"business-account": "企业账户",
		"business-info": "企业信息",
		"permission-management": "权限管理",
		"create-time": "创建时间",
		"set-column": "设置列",
		"industrial-equipment-manufacturing": "工业-设备制造",
		"industrial-equipment-maintenance": "工业-设备维修",
		"basic-info": "基本信息",
		'ProductID': '产品ID:',
		"equipment-info": "设备信息",
		"select-type": "选择类型",
		"work-order-type-required": "工单类型是必选项",
		"maintenance-name-required": "保养名称是必选项",
		"expected-service-time": "期望服务时间",
		"suggest-service-time": "建议服务时间",
		"service-time": "服务时间",
		"select-time": "选择时间",
		"work-order-content-required": "工单内容是必填项",
		"work-order-maintain-content-required": "维护项目是必填项",
		"work-order-content": "工单内容",
		"service-agent-supplement": "待服务代理补充",
		"attachment": "附件",
		"assist-engineer": "协助工程师",
		"expected-arrival-time": "预计到场时间",
		"expected-completion-time": "预计完工时间",
		"drag-drop-or-click-to-upload": "拖拽到此区域或点击上传",
		"cancel-work-order": "取消工单",
		"apply-reassign": "申请转派",
		"dispatch-confirmation": "派工确认",
		"complete-work-order": "工单已完成",
		"business": {
			"Channel1": "商机通道1: 实际订单值",
			"Channel2": "商机通道2: 巡检",
			"Channel3": "商机通道3: 保养套餐",
			"Channel4": "商机通道4: IoT",
			"OrderValueThisMonth": "商机价值",
			"EstimatedOrderValueThisMonth": "预估商机价值",
			"OrderVolumeThisMonth": "本月商机数",
			"本月返厂大修计划":"本月返厂大修计划",
			"全部返厂大修计划":"全部返厂大修计划",
			"本月一级保养计划":"本月一级保养计划",
			"全部一级保养计划":"全部一级保养计划",
			"本月二级保养计划":"本月二级保养计划",
			"全部二级保养计划":"全部二级保养计划",
			"延期保养计划":"延期保养计划",
			"全部延期保养计划":"全部延期保养计划",
			"待转化工单":"待转化工单",
			"已转化工单":"已转化工单",
			"已完成":"已完成",
		},
		"company-size": {
			"text": "公司规模",
			"less-than-25": "25人以下",
			"25-100": "25-100人",
			"100-300": "100-300人",
			"more-than-300": "300人以上",
		},
		"customer-attr": {
			"text": "客户属性",
			"non-ka": "非KA",
			"ka": "KA",
			"supporting-household": "配套户",
			"engineering-company": "工程公司",
			"export": "出口",
			'industry': '客户行业',
			'code': '客户编码',
			'address': '客户地址',
			'number': '客户电话',
			'email': '客户邮箱',
			'web': '客户官网',
		},
		"customer-industry": {
			"general": "通用",
			"chemical": "化工",
			"paper": "造纸",
			"oil-and-gas": "油气",
			"power": "电力",
			"nuclear-power": "核电",
		},
		"app-industry": {
			"Sugar production": "制糖",
			"Pharmaceuticals": "制药",
			"Chemical industry": "化工",
			"Medical treatment": "医疗",
			"Medicine": "医药",
			"Beer": "啤酒",
			"Municipal administration": "市政",
			"Organosilicon": "有机硅",
			"Nuclear power": "核电",
			"Spandex": "氨纶",
			"Wastewater": "污水",
			"Oil and gas": "油气",
			"Carbon black": "炭黑",
			"Tobacco": "烟草",
			"Coal chemical industry": "煤化工",
			"Coal": "煤炭",
			"Coal mine": "煤矿",
			"Electric power": "电力",
			"Electronics": "电子",
			"Petrochemical industry": "石化",
			"Mining": "矿业",
			"Grain and oil": "粮油",
			"Fiber": "纤维",
			"Equipment": "设备",
			"Tire": "轮胎",
			"General": "通用",
			"Papermaking": "造纸",
			"Paper mill supporting households": "造纸配套户",
			"Supporting": "配套",
			"Yeast": "酵母",
			"Steel": "钢铁",
			"Aluminum industry": "铝业",
			"Casting": "铸造",
			"Food": "食品"
		},
		"service-request": {
			"status": {
				"text": "状态",
				"to-be-classified": "待分类",
				"pending": "待处理",
				"processed": "已处理",
				"canceled": "已取消",
			}
		},
		"work-order": {
			"WorkOrdersThisMonth": "本月工单",
			"PendingAssignmentThisMonth": "本月待派工",
			"ClosedWorkOrdersThisMonth": "本月已完成",
			"CanceledWorkOrdersThisMonth": "本月已取消",
			"TotalWorkOrders": "全部工单",
			"TotalPendingAssignment": "待派工",
			"TotalClosedWorkOrders": "已完成",
			"TotalCanceledWorkOrders": "已取消",
			"create-order": "新建工单",
			"create-customer-contact-error": "新建客户联系人出错",
			"create-order-success": "工单创建成功",
			"create-order-error": "工单创建失败",
			"customer-required": "客户是必选项",
			"root-sn-required": "序列号是必选项",
			"contact-phone-required": "联系电话是必填项",
			"contact-required": "联系人是必填项",
			"address": "维修地址",
			"pump-head-sn": "泵头序列号",
			"unit-sn": "机组序列号",
			"number": "工单编号",
			"type": {
				"text": "工单类型",
				"device-repair": "设备维修",
				"device-maintenance": "设备保养",
				"installation-debugging": "安装调试",
				"fault-troubleshooting": "故障排除",
				"QR-code":"贴二维码",
				"maintenance-name": "保养名称",
				"current-status":"服务完成状态"
			},
			"current-status":{
				"finished":"完成",
				"further_visit_necessary":"需再次服务"
			},
			"device-name": "设备名称",
			"device-root-sn": "序列号",
			"warranty-status": {
				"text": "质保状态",
				"in-warranty": "在保",
				"out-warranty": "过保",
			},
			"contact": "联系人",
			"contact-phone": "联系电话",
			"customer-name": "客户名称",
			"priority": {
				"text": "紧急程度",
				"not-urgent": "不紧急",
				"urgent": "紧急",
				"very-urgent": "非常紧急",
			},
			"all-order": "全部工单",
			"status": {
				"text": "工单状态",
				"pending":"待处理",
				"to-be-assigned": "待派工",
				"unconfirmed": "待确认",
				"reassign": "待转派",
				"pending-construction": "待施工",
				"under-construction": "施工中",
				"awaiting-signature":"待签字",
				"completed": "已完成",
				"canceled": "已取消",
			},
			"value": "值",
			"name": "子设备名称",
			"copy": "复制",
			"bulk_copy": '批量复制',
			'all_copy': '总共复制',
			"in_copy": "复制中...",
			"copy_error": "复制失败，请重试！",
			"failed_to_device_list": "获取设备列表失败，请重试！",
			"failed_to_product_detail": "获取产品详情失败，请重试！",
			'ServiceInformation': '服务信息',
			'ValueNotSelectedInCustomerList': '顾客列表中没有选中的值：',
			'PackageName': '套餐名称',
			'PackageContent': '套餐内容',
			'ExpirationOfValidity': '有效期止',
			'Expires': '过期',
			"device": {
				"text": "设备",
				"rated_voltage": "额定电压",
				"name": "名称",
				"latest_value": "最新值",
				"unit": '单位',
				"latest_time": '最新时间',
				"no_device_create": "暂未创建设备",
				'device_create': "您可点击右上角按钮新建设备",
				"last_value_timestamp": "最新值时间戳",
				"equipment_delivery_information": "设备出厂信息",
				"device_management_information": "设备管理信息",
				"edit": "编辑设备",
				'create': '新建设备',
				'mkdev': '创建设备',
				'id': '设备ID:',
				'single': '单体设备',
				"unit_type": '机组类型',
				'delete': '删除设备',
			},
			"factory_engineer":'原厂工程师',
			"authorized_engineer":'授权工程师',
		}, 
		"tending": {
			"text": "维护保养",
			"item": "维护项目",
			"names": "维护保养名称",
			"description": "维护描述",
			'service_provider': '维保服务商',
			'select_service_provider': '请选择维保服务商',
			'enter_project_name': '请输入项目名称',
			'select_name': '请选择维护保养名称',
			'name_connot_be_null': '维护保养名称不能为空',
			'select_maintenance_period': '请选择维护周期',
			'maintenance_period_cannot_be_empty': '维护周期不能为空',
			'enter_description': '请输入描述',
			'add': '添加维护项',
			'maintenance_period': '维护周期',

		},
		'files_upload': {
			'click_upload_pictures_videos_documents': '点击上传图片、视频和文档',
			'click_upload_pictures_videos_documents_auditing': '点击上传服务回访文档',
			'type_auditing': 'EXCEL',
			'type': 'PPT、PDF、EXCEL、WORD、PNG、JPEG、JPG、MP4、MOV、GLB',
			'document_type': '\'.ppt,.pptx,.pdf,.xls,.xlsx,.doc,.docx,.png,.jpeg,.jpg,.mp4,.mov,.glb\'',
			'uploaded_data': '已上传资料',
			'file_size_cannot_exceed_50M': '文件大小不能超过50M!',
			'same_name_file': '相同名字文件已存在，不能重复上传!',
			'uploading': '上传中...'
		},
		'gauge_point': {
			'alias': '别名',
			'runnable_low': '可运行（低）',
			"ideal_low": '理想（低）',
			'ideal_high': '理想（高）',
			'runnable_high': '可运行（高）',
			'enter_threshold_range': '录入阈值范围',
			'threshold_range_is_not_entered': '不录入阈值范围',
			'unrecordable': '不可录入',
			'runnable_low_cannot_be_null': '可运行（低）不能为空',
			'ideal_low_cannot_be_null': '理想（低）不能为空',
			'ideal_high_cannot_be_null': '理想（高）不能为空',
			'runnable_high_cannot_be_null': '可运行（高）不能为空',
			'add': '添加测点',
			'show_or_not':'是否展示'
		},

		"no": "无",
		'solid': '占位',
		'contract_name': '合同名称',
		'first_party': '甲方',
		'second_party': '乙方',
		'contract_file': '合同文件',
		'contract_life': '合同有效期',
		'PleaseSelectProperties': '请选择属性',
		'delete_all_data': '您确定要删除吗？这将删除与此设备属性关联的所有数据。',
		'parent_child_node': '当前设备已有父子节点，请先解除层级关系。',
		'parent_node': '当前设备已有父节点，请先解除层级关系。',
		'child_node': '当前设备已有关联设备，请先解除层级关系。',
		'edit_parent': '编辑父节点',
		'edit_child': '编辑设备',
		'character_length_cannot_exceed_50': '字符长度不能超过50',
		'device_name_cannot_be_empty': '设备名称不能为空',
		'form_verification_failed': '表单校验未通过,请检查表单是否填写完整!',
		'initialize_the_fetch_list': '初始化获取列表....',
		'ready_fetch_list': '准备获取列表',
		'fetch_result': '结果获取到：',
		'submitting': '提交中...',
		'edit_success': '编辑设备信息成功!即将返回上一页',
		'sava_fail': '保存失败:',
		'device_create_success': '创建设备信息成功!即将返回上一页',
		'create_fail': '创建失败:',
		'product_name_cannot_null': '产品名称不能为空，请重新输入！',
		'device_name_cannot_null': '设备名称不能为空，请重新输入！',
		'current_device_already_exists': '当前设备已存在',
		'value_must_double_precision_number.': '必须为双精度数。',
		'data_type_double_default_value_fail': '属性定义中数据类型为双精度数类型时,默认值填写不正确！',
		'must_be_integer': '必须为整数。',
		'data_type_integer_default_value_fail': '属性定义中数据类型为整数时，默认值填写不正确！',
		'input_true_or_false': '输入true或false',
		'data_type_bool_default_value_fail': '属性定义中数据类型为布尔类型时,默认值填写不正确！',
		'tending_threshold_range_cannot_be_empty': '测点阈值范围不能为空，请重新输入！',
		'duplicate_alias': '别名重复',
		'tending_duplicate_alias': '测点别名重复，请重新输入！',
		'maintenance_item_name_cannot_exceed': '维护项目名称长度不能超过50，请重新输入！',
		'maintenance_item_name_cannot_empty': '维护项目名称不能为空，请重新输入！',
		'maintenance_name_cannot_empty': '维护保养名称不能为空，请重新输入！',
		'maintenance_period_cannot_empty': '维护保养周期不能为空，请重新输入！',
		'maintenance_item_name_must_unique': '维护项目名称不能重复，请重新输入！',
		'maintenance_item_name_must_same_cycle': '相同维护项目名称必须保持相同周期，请重新输入！',
		'MeasurementPointNameCannotExceed': '测点定义中名称长度不能超过50，请重新输入!',
		'MeasurementPointNameCannotEmpty': '测点定义中名称不能为空，请重新输入！',
		'MeasurementPointDataTypeCannotEmpty': '测点定义中数据类型不能为空，请重新选择！',
		'MeasurementPointUnitCannotExceed': '测点定义中单位长度不能超过50，请重新输入！',
		'MeasurementPointNameCannotRepeated': '测点定义中名称不能重复，请重新输入！',
		'GroupNameCannotBeRepeatedInThePropertyDefinition': '属性定义中组名称不能重复！',
		'AttributeNamesInTheSameGroupOfAttributesCannotBeTheSameInTheAttributeDefinition': '属性定义中同组属性内属性名称不能重复！',
		'AttributeDefinitionGroupNameCannotExceed': '属性定义中组名称长度不能超过50，请重新输入！',
		'AttributeDefinitionGroupNameCannotEmpty': '属性定义中组名称不能为空，请重新输入！',
		'AttributeDefinitionNameCannotExceed': '属性定义中名称长度不能超过50，请重新输入！',
		'AttributeDefinitionNameCannotEmpty': '属性定义中名称不能为空',
		'AttributeDefinitionDataTypeCannotEmpty': '属性定义中数据类型不能为空，请重新选择！',
		'AttributeDefinitionDefaulteLengthCannotExceed': '属性定义中默认值长度不能超过50，请重新输入！',
		'ParentProductCannotBeEmpty': '父类产品不能为空，请选择！',
		'BasicInformationNameLengthCannotExceed': '基本信息中名称长度不能超过50，请重新输入！',
		'BasicInformationNameCannotEmpty': '基本信息中名称不能为空，请重新输入！',
		'LastModificationTime': '上次修改时间',
		'DateCreated': '创建日期',
		'AttributeDefinition': '属性定义',
		'MeasurementPoint': '测点定义',
		'NoAttributeDefinition': '无属性定义',
		'NoMeasurementPoint': '无测点定义',
		'UndeletedInstancesCurrentProduct': '当前产品下有未删除的设备，请先删除设备。',
		'ViewingAssociatedDevices': '查看关联设备',
		'DragDropFilesSelectFileUpload': '拖拽文件到此区域或者选择文件上传',
		'unauthorized': '未授权',
		'CurrentUseHasNoAccessPermission': '当前用户没有访问权限，请联系管理员授权后重试',
		'PleaseUploadAttachment': '请上传附件',
		'CurrentStatusIsRequired':'服务完成状态为必填项！',
		'ConstructionRecordsWereSuccessfullyAdded': '施工记录添加成功',
		'InitialStatusAddedSuccessfully': '现场情况说明添加成功',
		'device-attr': {
			'contact_number': '设备联系人电话',
			'contacts': '设备联系人',
			'Select_Down': '请先选择下方客户名称',
			'SelectUpperCustomer': '请先选择上方客户名称',
			'customer_purchasing_contact_number': '客户采购联系人电话',
			'customer_purchasing_contact': '客户采购联系人',
			'delivery_time': '发货时间',
			'created_time': '设备创建时间',
			'number': '设备联系电话',
			'warranty_start_time': '质保开始时间',
		},
		'product-info': {
			'text': '产品信息',
			'type': '产品类型',
			'name': '产品',
			'select': '请选择产品',
			'model_name_cannot_be_null': '模型名称不能为空',
		},
		"service-report": {
			text: "服务报告",
			"type": {
				"text": "报告类型",
				"service-report": "服务报告",
				"return-visit-report": "回访报告",
				"acceptance-report": "开箱验收报告",
				"on-site-training": "现场培训",
				"maintenance-report": "维修报告",
				"debugging-report": "设备调试报告",
			}
		},
		"role-management": {
			"current-role": "当前角色",
			"add-role": "添加角色",
			"role": "角色",
			"no-role": "暂无角色",
			"role-permissions": "角色权限",
			"new-role": "新角色",
			"Please set the name for the new role": "请为新角色设置名称",
			"New role added successfully!": "新角色添加成功！",
			"Failed to add new role!": "添加新角色失败!",
			"Role name updated successfully!": "角色名称更新成功!",
			"Failed to update role name!": "更新角色名称失败!",
			"Delete this role?": "删除该角色？",
			"Please delete the sub-roles first!": "请先删除子角色！",
			"Please select the role you want to operate on!": "请选择您要操作的角色！",
			"please-select-role": "请选择父角色",
			"Please save the newly created role first!": "请先保存新建的角色！",
			"Invalid role": "无效的角色",
			"Role permissions updated successfully!": "角色权限更新成功！",
			"Failed to update role permissions!": "更新角色权限失败！",
			"Delete all permissions of this role?": "删除该角色的所有权限？",
			"Role permissions deleted successfully!": "角色权限删除成功！",
			"Failed to delete role permissions!": "删除角色权限失败！",
			"代理商": "代理商",
			"工程师": "工程师",
			"基本用户": "基本用户",
			"客户": "客户",
			"设备联系人": "设备联系人",
			"管理员": "管理员",
		},
		"user": {
			"unfreeze_account": "解冻账户",
			"freeze_account": "冻结账户",
			"role": "角色",
			"account": "账号",
			"name": "姓名",
			"email": "邮箱",
			"contact number": "联系电话",
			"status": "状态",
			"unregistered": "是否注册",
			"normal": "正常",
			"freeze": "冻结",
			"Account information": "账号信息",
			"Select status": "选择状态",
			"reset_password": "重置密码",
			"department": "部门",
			"position": "职位",
			"label": "标签",
			'post': '岗位',
			'contact_address': '联系地址',
			'CurrentPassword': '当前密码',
			'NewPassword': '新密码',
			'ConfirmPassword': '确认密码',
			'registered_text': '已注册',
			'unregistered_text': '未注册',
			'user_exists':'该账户已存在!',
			'phone':'电话',
		},
		"business-partner": {
			"procurementContact": "采购联系人",
			"contact": "联系人",
			"qualification": "企业资质",
			"contract": "合同",
		},
		"no_image": "暂无图片",
		"create_time": "创建时间",
		"construction_time": "施工时间",
		"cancel_order": "取消工单",
		"apply_for_transfer": "申请转派",
		"dispatch_confirmation": "派工确认",
		"complete_work_order": "完成工单",
		"client_signature":"申请客户签字",
		"work_order_progress": "工单进度",
		"service_company": "服务公司",
		"customer_name": "客户名称",
		"estimated_arrival_time": "预计到场时间",
		"estimated_completion_time": "预计完工时间",
		"pump_head_serial_number": "泵头序列号",
		"device_name": "名称",
		'EquipmentManufacturer': "设备厂商",
		"unit_serial_number": "机组序列号",
		"locationOn": "所在位置",
		"work_order_content": "工单内容",
		"on_site_check_in": "现场签到",
		"must operate on mobile": "必须在移动端操作",
		"construction_site": "施工现场",
		"initial_status": "现场情况说明",
		"remaining_issus": "待办事项处理意见",
		"work_order_attachments": "工单附件",
		customer_feedback: '客户反馈',
		problem_description: '问题描述',
		industry: '行业',
		contact_number: '联系电话',
		email: '电子邮箱',
		homepage: '官方网站',
		company_address: '公司地址',
		contact: "联系人",
		serviceEvaluation: "服务评价",
		serviceQuality: "服务质量",
		serviceAttitude: "服务态度",
		responseSpeed: "响应速度",
		customerMessage: "客户留言",
		signature:"客户签字",
		veryProfessional: "非常专业，很快解决了问题",
		canceled: "已取消",
		dispatched: "派工",
		construction: "施工",
		completedWorkOrder: "完工",
		completed: "已完成",
		processWait: "待",
		workOrderProcessing: "运行中",
		toBeConfirmed: "待确认",
		"deviceInfo": "设备信息",
		"maintenanceRecord": "维保记录",
		"relatedWorkOrder": "关联工单",
		"relatedServiceRequest": "关联服务请求",
		"powerOnTime": "开机时间",
		"deviceStatus": "设备状态",
		'applicationIndustry': '应用行业',
		"workOrderCreationTime": "工单创建时间",
		"estimatedArrivalTime": "预计到场时间",
		"estimatedCompletionTime": "预计完工时间",
		"customerName": "客户名称",
		device_category: '设备分类',
		model: '型号',
		status: '状态',
		allType: '全部类型',
		report_number: '报告编号',
		type: '类型',
		device_serial_number: '设备序列号',
		customer: '客户',
		contact_person: '联系人',
		contact_phone: '联系电话',
		write_time: '填写时间',
		serviceReport: '服务报告',
		add: '添加',
		reportNumberCustomerNameAgentDeviceSerialNumber: '报告编号/客户名称/代理商/设备序列号',
		reportNumberCustomerNameAgentDeviceSerial: '报告编号/代理商/设备序列号',
		selectCreationTime: '选择创建时间',
		pleaseSelectType: '请选择类型',
		filter: '筛选',
		reset: '重置',
		operation: '操作',
		create: '新建',
		wrongEmailFormat: '邮箱格式错误！',
		pleaseCompleteTheRequiredInformation: '请完善必填信息！',
		errorOnCreatingCustomerContact: '新建客户联系人出错',
		serviceReportCreatedSuccessfully: '服务报告创建成功',
		'Customer_creation_success': '客户创建成功',
		"reportType": "报告类型",
		"pumpHeadSerialNumber": "泵头序列号",
		"contactPhone": "联系电话",
		"fillingTime": "填写时间",
		"reportFile": "报告文件",
		notEditable: '当前状态不可修改',
		deleteConfirm: '确定要删除？',
		afterSalesService: '售后服务',
		businessPartner: '商业伙伴',
		agentName: '代理商名称',
		location: '位置',
		detailedAddress: '详细地址',
		"select-industry": "请选择行业",
		"enterprise-contact": "企业联系人",
		"please-select-area": "请选择地区",
		"please-select-role": "请选择角色",
		"downloading": "下载即将开始，请稍后...",
		"fileDownloaded": "文件已下载！",
		"clickHere": "点击此处",
		"startDownload": "开始下载！",
		"errorOccurred": "出现错误！",
		"ifNotDownload": "如果您的文件没有自动下载，点击",
		"please-select-company-size": "请选择公司规模",
		"companyIntroduction": "公司介绍",
		"registerStatus": "注册状态",
		"selectRegisterStatus": "请选择注册状态",
		"selectRegisterTime": "请选择注册时间",
		"contactNumber": "联系电话",
		"officialWebsite": "官方网站",
		"companyAddress": "公司地址",
		"establishedTime": "成立时间",
		"companySize": "公司规模",
		"valid": "有效",
		"expired": "已失效",
		"no-equipment-record": "暂未产生设备记录",
		"business-status": {
			"pending": "待转化",
			"converted": "已转化",
			"completed": "已完成",
		},
		"business-number": "商机编号",
		"maintenance-name": "保养名称",
		"device-type": "设备类型",
		"delay-status": "延期状态",
		"delay-reason": "延期原因",
		"delay-or-complete-reason": "延期原因/完成原因",
		"business-finish-time": "完成时间",
		"all": "全部",
		'NoOption': '暂无选项',
		'NoResultFound': '未找到结果',
		"health-monitoring": {
			"threshold_interval_diagram": '阈值区间图',
			"historical_data": '历史数据',
			'search': '搜索',
			'refresh_rate': '刷新频率:',
			'Every3Seconds': '每3秒',
			'Every15Seconds': '每15秒',
			'Every60Seconds': '每60秒',
			'viewing_historical_data': '查看历史数据',
			'unfold': '展开',
			'pack_up': '收起',
			'health_monitoring_list': '健康监控列表',
			'measuring_point_name': '测点名称',
			'EarlyWarningState': '预警状态',
			'LastUpdateTime': '最后更新时间',
			'CurrentValue': '当前值',
			'UnitName': '机组名称',
			'DeviceArea': '设备所在区域',
			'search_placeholder': '搜索客户名称/序列号/行业/应用',
			'custom': '客户',
			'monomer': '单体',
			'set': '机组',
			'serialNumber': '序列号',
			'type': '类型',
			'type1': '型号',
			'status': '运行状态',
			'status1': '健康状态',
			'time': '运行时长',
			'scene': '行业-应用',
		},
		'event-management': {
			'search_placeholder':'序列号/客户名称',
			'EventRecording': '事件记录',
			'EventNumber': '事件编号',
			'IntelligentAlarm': '智能报警',
			'warning': '警告',
			'error': '错误',
			'reminder': '提醒',
			'AffectedEquipment': '受影响设备',
			'AffectedSensor': '受影响传感器',
			'OccurrenceTime': '发生时间',
			'PredictiveMaintenanceModule': '预测性维护模块',
			'BriefDescription': '简要描述',
			'AbnormalPerformancePleasePayAttention': '表现异常，请关注。',
			'enter': '进入了',
			'EventMap': '事件图谱',
			'FaultCauseAnalysisSuggestions': '故障原因分析建议',
			'RelatedProcessDescription': '相关工艺说明',
			'RelativeResults': '相关结果',
			'EventBase': '事件库',
			'UpdateTime': '更新时间',
			'EventReport': '事件报告',
			'DescribeEventImpactProblem': '在下面文本框中描述事件、影响和解决问题的方式。',
			'HistoricalReport': '历史报告',
			'NoHistoricalReport': '暂无历史报告',
			'click_upload_pictures': '点击上传图片',
			'UploadedPicture': '已上传图片',
			'NoUploadedPicture': '暂无已上传图片',
			'ClickUploadDocument': '点击上传文档',
			'UploadedDocument': '已上传文档',
			'NoUploadedDocument': '暂无已上传文档',
			"sub-health": '亚健康',
			'abnormal': '异常',
			'health': '健康',
			'unknown': '未知',
			'FileWithTheSameNameAlreadyExists': '相同名字文件已存在，不能重复上传!',
			'EventPicture': '事件图片',
			'DynamicThresholdHigh': '动态阈值（高）',
			'DynamicThresholdLow': '动态阈值（低）',
			'EventType': '事件类型',
			'EventStatus': '事件状态:',
			'EventList': '事件列表',
			'status': '事件状态',
			'RequestFailedPleaseTryAgain': '请求失败, 请重试!',
			'DeviceHasNoEventRecord': '当前设备暂无任何事件记录',
			'FailedGetEventListPleaseTryAgain': '获取事件列表失败,请重试！',
			'FailedGetEventDetailPleaseTryAgain': '获取事件详情失败,请重试！',
			'BatchModification': '批量修改中...',
			'BatchModifying': '批量修改!',
			'StatusChangedSuccessfully': '修改状态成功',
			'FailedModifyStatusPleaseTryAgain': '修改状态失败,请重试！',
			'start': '开启',
			'BeingProcessed': '处理中',
			'WaitForConfirmation': '等待确认',
			'closed': '已关闭',
			'HavePublished': '已发布',
			'resloved': '已解决',
		},
		'atlas-analysis': {
			"SelectedData": '已选数据',
			'time granularity': '时间粒度',
			'reach': '至',
			'StaticThreshold': '静态阈值：',
			'DynamicThreshold': '动态阈值：',
			'PleaseFirstDragTheMeasuringPointOnTheLeftSideToPlaceItOnTheChart': '请先在左侧拖拽测点放置于图表',
			'sed': '秒',
			'min': '分钟',
			'hour': '小时',
			'day': '天',
			'Last7Days': '最近7天',
			'ThisMonth': '本月',
			'LastMonth': '最近一个月',
			'TMonth': '最近三个月',
			'CreatedAt': '创建于',
			'ChartAnnotation': '图表注释',
			'DataSnapshots': '数据快照',
			'SelectMeasurement': '请从左侧选择测量值拖拽至此框',
			'AITechnologyTool': '以人工智能技术为工具，实现设备维护智能化升级。通过数据挖掘技术，识别隐藏在数据中的工艺特征的相关性，以便及时发现生产质量异常的成因，提升生产线运行水平。',
			'OfAnnotation': '的注释',
			'face': '对',
			'describe': '描述:',
			'PleaseInput': '请输入',
			'SelectPatternColor': '选择图案颜色：',
			'SelectedRangeExceedsTheMaximumDataLimit': '所选范围超出最大数据限制！',
			'1MillInputShaftAxialX': '1#轧机输入轴轴向（X）',
			'1MillInputShaftAxialY': '1#轧机输入轴轴向（Y）',
			'GenerateAlarm1111': '振动值超出阈值范围，产生报警1111',
			'GenerateAlarm2222': '振动值超出阈值范围，产生报警2222',
			'GenerateAlarm1234': '振动值超出阈值范围，产生报警1234',
			'ChooseMaximumOf6MeasuringPoints': "最多选择6个测点",
			'Annotation': '注释',
			'DT': "动态阈值",
			'MapDataRequestFailed': "图谱数据请求失败",
			'PleaseSelectCommentNodeLineChart': '请在折线图中选中注释节点',
			'PleasePlaceLeft': '请先在左侧拖拽测点放置于此。',
			'TriggerEvent': '触发事件',
			'TriggeredMethod': '间隔大于2秒，触发方法',
			'NoTrigger': "不触发",
			'DataScience': '数据科学',
			'ComingSoon': '敬请期待!',
		},
		'expert-system': {
			'ExpertStatement': '专家说明',
			'ProcessDescription': '工艺说明',
			'ThresholdProcessManagement': '阈值及工艺管理',
			'ThresholdManagement': '阈值管理',
			'Enabled': "已启用",
			'NotEnabled': '未启用',
			'CanontBeEmpty': "不能为空",
			'MustBeANumber': '必须为数字',
			'CurrentDetectionPointThresholdNotEnabled': '当前测点的可录入阈值开关未开启,点击下方按钮进行操作',
			'StaticThresholdSwitchCannotBeOperated': '当前测点的可录入阈值开关未开启,不可操作静态阈值开关,点击下方按钮进行操作',
			'go': '前往',
			'EditObjectInstance': "编辑物实例",
			'ChangingStaticThresholdSucceeded': '修改静态阈值成功！',
			'FailedModifyStaticThresholdPleaseTryAgain': '修改静态阈值失败，请重试！',
		},
		'personal-information': {
			text: '个人信息',
			'ChangePassword': '修改密码',
		},
		'product-library': {
			'SelectTheProductLibraryBaseType': '选择产品库基础类型',
			'DefinitionOfProduct': '产品包含了一类设备的通用属性名称、层级、方法和组成的定义。',
			'SearchForProductName': '搜索产品名称',
			'CreateProduct': '创建产品',
			'CreateProductsAtThisLevel': '以此层级创建产品',
			'ViewDetails': '查看详情',
			'NewProduct': '新建产品',
			'PleaseEnterAGroupName': '请输入组名称',
			'PleaseEnterAPropertyName': '请输入属性名称',
			'SelectADefaultValueForTheProperty': '请选择属性默认值',
			'PleaseEnterTheDefaultValueOfTheProperty': '请输入属性默认值',
			'AreYouSureWantDelete': '您确定要删除吗',
			'DefaultVlue': "默认值",
			'PleaseEnterName': '请输入名称',
			'ProductManagement': '产品管理',
			'EditProduct': '编辑产品',
			'OtherInformation': '其他信息',
			'maintain': '维护',
			'RequestFailedPleaseTryAgain': '请求失败,请重试',
			'SavedSuccessfullyWillJumpDetailsPage': '保存成功，即将跳转到详情页',
			'ProductNameHasBeenRepeated': '产品名称已重复，请重新输入',
			'CreationSuccessfulWillJumpProductPage': '创建成功，即将跳转到产品界面',
			'PleaseEnterThePointName': '请输入测点名称',
			'PleaseEnterThePointUnit': '请输入测点单位',
			'NoProductHasBeenCreated': '暂未创建产品',
			'YouCanCreateANewProduct': '您可点击右上角按钮新建产品',
			'LatestTimestamp': '最新时间戳',
			'DeleteProduct': '删除产品',
			'FailedToGetProductList': '获取产品列表失败，请重试！',
			'FailedToGetProductDetails': '获取产品详情失败，请重试！',
			'ThisProductAssociatedInstance': '此产品关联了实例，请解除关联后再进行删除操作',
			'ProductName': '产品名称',

		},
		'select-maintenance-name': '选择保养名称',
		'maintenance-item': '维护项目',
		'please-check-maintenance-item': '请在下方勾选此次工单要执行的维护项目，如果没有请手动输入。',
		'repair-request': {
			'RequestsThisMonth': '本月请求',
			'PendingRequestsThisMonth': '本月待处理',
			'ClosedRequestsThisMonth': '本月已处理',
			'CanceledRequestsThisMonth': '本月已取消',
			'SelectRequestType': '选择请求类型',
			'TotalPendingRequests': '全部待处理',
			'TotalClosedRequests': '全部已处理',
			'TotalCanceledRequests': '全部已取消',
			'NotClassified': '未分类',
			'CancelRequest': '取消请求',
			'PleaseEnterReasonForCancellation': '请输入取消原因',
			'TotalRequest': '全部请求',
			'FaultMessage': '故障信息',
			'TheFieldUpdatedTo': '字段更新为',
			'CancelReason': '取消原因',
			'SettlementRecord': '解决记录',
			'DirectSolution': '直接解决',
			'CreateWorkOrder': '创建工单',
			'RecordDescription': '记录描述',
			'SolicitedMessage': '请求信息',
			'RequestType': '请求类型',
			'TheDegreeOfUrgencyIsRequired': '紧急程度是必填项',
			'TheCompanyNameIsRequired': '公司名称是必选项',
			'TheRootSNIsRequired':'序列号是必选项',
			'ExpectedServiceTimeIsRequired': '期望服务时间是必选项',
			'DeviceQueryFailure': '设备查询失败',
			'AfterSelectingTheEquipment': '选择设备后...',
			'ValuesNotSelectedInTheDeviceList': '设备列表中没有选中的值：',
			'CurrentDeviceSerialNumberChanges': '当前设备序列号变化：',
			'GetStateFailure': '获取国家失败：',
			'remaining': '剩余',
			'service_request_no':'服务请求号'
		},
		'maintenance': {
			'FirstLevelMaintenance': '一级保养',
			'SecondLevelMaintenance': '二级保养',
			'ReturnToFactoryForOverhaul': '返厂大修',
			'DailyMaintenance': '日常保养',
			'EveryYear': '每1年',
			'EveryTwoYears': '每2年',
			'EveryThreeYears': '每3年',
			'EveryFiveYears': '每5年',
			'EveryEightYears': '每8年',
			'EveryDay': '每天',
			'EveryWeek': '每周',
			'EveryMonth': '每月',
			'EveryQuarter': '每季度',
			'EveryHalfYear': '每半年',
		},
		'please-enter-content': '请输入内容',
		'overdue': '已延期',
		'not-overdue': '未延期',
		'no-explain': '暂无说明',
		'add-explain': '新增说明',
		'view-more': '查看更多',
		'business-delay-reason': {
			'-1': '未填写',
			'1': '现场无此设备',
			'2': '联系人信息错误',
			'3': '客户自行维保',
			'4': '根据停机时间另约',
			'5': '不需要上门维保，只采购备件',
		},
		'get-explain-fail': '获取说明失败',
		'add-explain-success': '添加说明成功',
		'add-explain-fail': '添加说明失败',
		'get-maintenance-item-fail': '获取设备维护项失败',
		'business-confirm-transfer': '转化为工单？',
		'business-confirm-cancel-transfer': '撤回转化？',
		'unread messages': '未读消息',
		'unread': '未读',
		'notifications': '通知',
		'new': '新',
		'begin-month': '开始月份',
		'end-month': '结束月份',
		'parent-product-not-null': '父产品不能为空。',
		'name-not-null': '名称不能为空。',
		'length-not-more-than-50': '字符长度不能超过50。',
		'length-not-more-than-200': '字符长度不能超过200。',
		'data-type-not-null': '数据类型不能为空。',
		'maintenance-download-title': '保养',
		'business-opportunity-download-title': '商机',
		'work-order-download-title': '工单',
		'history-explain': '历史说明',
		'explanation': '说明',
		'downloading...': '下载中...',
		'Real-Time Data Chart': '实时数据图',
		'start-time': '开始时间',
		'end-time': '结束时间',
		'logout': '退出',
		'feedback_content_placeholder': '您如果有其他意见和建议，请放心填写。',
		'rate': {
			'0': '请打分',
			'1': '1分',
			'2': '2分',
			'3': '3分',
			'4': '4分',
			'5': '5分',
		},
		'feedback_submit': '提交评价',
		'quality_required': '请给服务质量打分',
		'attitude_required': '请给服务态度打分',
		'response_speed_required': '请给响应速度打分',
		'please-evaluate': '请对本次工单为您服务的工程师做出评价',
		'no-evaluate':'暂未签字',
		'pending-evaluation': '待评价',
		'less-than-3-points': '低于3星',
		'more-than-3-points': '3星及以上',
		'products': '产品',
		'select_is_qrcode_bind': '是否绑定二维码',
		'registered': '已注册',
		'unregistered': '未注册',
		'register_time': '注册时间',
		'no_checkin_address': '未获取到定位地址',
		'parts_amount': '备件金额',
		'parts_explain': '备件说明',
		'reason_explain': '原因说明',
		fault:{
			'fault_knowledge_base':'故障知识库',
			'correlative_measuring_points':'相关测点',
			'fault_classification_required':'故障类型不能为空',
			'fault_description':'故障说明',
			'fault_symptoms':'故障表现',
			'fault_cause':'故障原因',
			'resolution':'解决办法',
			'add_fault_information':'添加故障信息',
			'add_fault_description':'添加故障说明',
			'no_fault_description':'无故障说明',
		},
		'energy_consumption_analysis':{
			'智能系统年度总收益':'智能系统年度总收益',
			'机组年度节电收益':'机组年度节电收益',
			'机组':'机组',
			'节能图表':'节能图表',
			'节约电费':'节约电费',
			'减少CO2排放':'减少CO2排放',
			'总电费':'总电费',
			'产生CO2排放':'产生CO2排放',
			'节水收益':'节水收益',
		},
		'energy_consumption_management':{
			'title':'能耗管理',
			'每度电煤耗':'每度电煤耗',
			'CO2交易价格':'CO2交易价格',
			'煤炭价格':'煤炭价格',
			'电费的价格':'电费的价格',
			'预测性维护节省收益':'预测性维护节省收益',
			'data_name':'数据名称',
			'value':'数值',
		},
		"auditing":{
			"title":"设备巡检工单",
			"service_follow_up":"服务回访",
			"service_upload":"服务上传",
			"work_order_number":"工单编号",
			"type":"类型",
			"customer_level":"客户等级",
			"latest_completion_time":"最晚完成时间",
			"work_order_status":"工单状态",
			"delay_status":"延期状态",
			"customer_name":"客户名称",
			"service_provider":"维修服务商",
			"sales_service_engineer":"销售服务工程师",
			"contact":"联系人",
			"contact_phone":"联系电话",
			"service_report_status":"服务报告状态",
			"amount":"金额",
			"order_feasibility":"成单可行性",
			"service_report":{
				"in_progress":"执行中",
				"to_review":"待审核",
				"to_sign":"待签字",
				"signed":"已签字",
			},
			"service_process":"服务过程",
			"KA_customer_level":"KA客户等级",
			"province":"省份",
			"detailed_address":"详细地址",
			"last_execution_time":"上次执行时间",
			"work_order_notes":"工单备注",
			"dispatch_information":"派工信息",
			"service_type":"服务类型",
			"history":"历史",
			"customer_contact":"客户联系人",
			"NASH_service":"NASH服务",
			"technical_service_engineer":"技术服务工程师",
			"agent_service":"代理服务",
			'repair_service_engineer':"返修服务工程师",
			"authorized_service_engineer":"授权服务工程师",
			"service_progress":"服务进度",
			"customer_signature":"客户签名",
			"Basic Contact Information":"联系人基本信息",
			"departure_time":"出发时间",
			"arrival_time":"到达时间",
			"leave_time":"离开时间",
			"Equipment Information":"设备信息",
			"unallocated_individual_equipment":"未分配单体设备",
			"name":"名称",
			"position_no":'设备位号',
			"installation_and_debugging_time":"安装及调试时间",
			"operation_time":"投运时间",
			"factory_release_time":"出厂时间",
			"uploaded_nameplate":"上传铭牌",
			"equipment_appearance":"设备外观",
			"equipment":"设备",
			"Diagnostic Records":"诊断记录",
			"possible_abnormal_measurement_points":"可能异常测点",
			"fault_performance":"故障表现",
			"preliminary_analysis_reason":"初步分析原因",
			"solution":"解决方法",
			"remarks":"备注",
			"maintenance_suggestions":"维保建议",
			"enter_maintenance_suggestions":"输入维保建议",
			"add_maintenance":"新增维保",
			"specification":"规格",
			"quantity":"用量",
			"spare_parts_suggestions":"配件建议",
			"opportunity_name":"商机名称",
			"opportunity_type":"商机类型",
			"stage":"阶段",
			"estimated_value":"预估价值",
			"total":"合计",
			"opportunity_conversion":"商机转换",
			"measurements":"设备测点",
			"是否删除该设备":'是否删除该设备?',
			"select_equipment":'选择设备',
			"equipment_list":'设备列表',
			"undiagnosed_equipment":'未诊断设备',
			"add_diagnosis":'添加诊断',
			"suggestions":"建议",
			"service_suggestions":"服务建议",
			"add_service":"添加服务",
			"no_recommended_equipment":"未建议设备",
			"abnormal_equipment":'异常设备',
			"add_contact":'添加联系人',
			"selcet_contact":'选择联系人',
			"请在小程序上签到":"请在小程序上签到",
			"submit_approval":"提交审核",
			"驳回原因":"驳回原因",
			"审核通过后等待签字验收":"审核通过后，会生成服务报告推送给设备联系人，等待签字验收。",
			"repairs":"维修",
			"maintenance":"保养",
			"spare_parts":"备件",
			"repair_level":{
				"overhauls":"大修",
				"medium_repair":"中修",
				"minor_repairs":"小修",
			},
			"units":"台",
			"bit_no":"位号",
			"unit_usage":"台用量",
			"technical_transformation":"技改",
			"replace":"替换",
			"normal_equipment":"正常设备",
			"是否可能异常":"是否可能异常",
			"health_score":"健康评分",
			"measurement_point_value":"测点值",
			"是否正常":"是否正常",
			"fault_name":"故障名称",
			'fault_description':'故障描述',
			"初步分析原因":"初步分析原因",
			"可能造成影响":"可能造成影响",
			"建议解决方案":"建议解决方案",
			"suggest_types":"建议类型",
			"maintenance_type":"维保类型",
			"maintenance_project":"维保项目",
			"accessories_type":"配件类型",
			"请优先选择配件类型":"请优先选择配件类型！",
			"accessories_list":"配件清单",
			"quantity_label":"数量",
			"GDNC_description":"GDNC描述",
			"add_new_contact":"新增联系人",
			"不存在":'不存在',
			"商机转换未填写，请填写完整后提交审核":"商机转换未填写，请填写完整后提交审核！",
			"服务过程未完成":"服务过程未完成！",
			"诊断记录未填写完整":"诊断记录未填写完整，请填写完整后提交审核！",
			"服务建议未填写完整":"服务建议未填写完整，请填写完整后提交审核！",
			"商机转换未填写":"商机转换未填写，请填写完整后提交审核！",
			"铭牌删除成功":"铭牌删除成功！",
			"设备外观删除成功":"设备外观删除成功！",
			"铭牌上传成功":"铭牌上传成功！",
			"设备外观上传成功":"设备外观上传成功！",
			"只能输入整数":"只能输入整数！",
			"请填写设备信息":"请填写设备信息！",
			"删除联系人":"删除联系人",
			log:{
				"待施工":"待施工",
				"您的设备巡检已被受理，销售工程师":"您的设备巡检已被受理，销售工程师",
				"增加协助人": "增加协助人",
				"新增了技术服务工程师": "新增了技术服务工程师",
				"新增了授权服务工程师": "新增了授权服务工程师",
				"更换协助人": "更换协助人",
				"您的技术服务工程师更换": "您的技术服务工程师更换",
				"您的授权服务工程师更换": "您的授权服务工程师更换",
				"已签到": "已签到",
				"服务人员": "服务人员",
				"服务地点": "服务地点",
				"更换Owner": "更换Owner",
				"您的销售服务工程师更换": "您的销售服务工程师更换",
				"提交审核": "提交审核",
				"技术工程师": "技术工程师",
				"销售工程师": "销售工程师",
				"审核通过": "审核通过",
				"审核不通过": "审核不通过",
				"审核拒绝，拒绝原因": "审核拒绝，拒绝原因",
				"服务报告签字": "服务报告签字",
				"已完成": "已完成",
				"客户联系人":"客户联系人",
				"已完成服务报告签字":"已完成服务报告签字",
				"所有服务报告签字完成，设备巡检工单完成":"所有服务报告签字完成，设备巡检工单完成。",
			},
			"销售服务工程师修改成功":"销售服务工程师修改成功！",
			"技术服务工程师修改成功":"技术服务工程师修改成功！",
			"代理服务修改成功":"代理服务修改成功！",
			"授权服务工程师修改成功":"授权服务工程师修改成功！",
			"暂无联系人":"暂无联系人",
			"暂无图片":"暂无图片",
			"请完善设备测点":"请完善设备测点！",
			"请选择设备":"请选择设备！",
			"请填写故障的故障名称":"请填写故障的故障名称",
			"请填写初步分析原因":"请填写初步分析原因",
			"请对设备做出体检评分":"请对设备做出体检评分！",
			"请选择建议类型":"请选择建议类型！",
			"请填写维保类型和维保项目":"请填写维保类型和维保项目！",
			"请填写配件类型":"请填写配件类型！",
			"请填写设备型号":"请填写设备型号！",
			"请填写Care类型":"请填写Care类型！",
		},
	},
	menu: {
		dashboard: {
			text: "Dashboard",
		},
		"after-sales_service": {
			text: "售后服务",
			"service_request": "服务请求",
			order: {
				text: "工单管理",
				"equipment-repair": "设备维修",
				"equipment-maintenance": "设备保养",
				"installation-debugging": "安装调试",
				"troubleshooting": "故障排除",
			},
			report: "服务报告",
			"business-opportunity": "商机管理",
			"maintenance-plan": "保养计划",
		},
		"equipment-management": {
			text: "设备管理",
			'search': '名称/序列号/产品型号',
			"model-management": {
				text: "模型管理",
				model: "产品库",
				instance: "设备"
			},
			equipment: "设备管理",
			"AddEquipment": '添加设备',
			'export': '设备导出',
			'import': '设备导入',
			'ColumnSelected': '列已选择',
			'QrcodeExport': '二维码导出',
			'EnterDeviceInformationClick': '请根据模版文件要求填写设备信息后使用导入功能，点击',
			'download': '下载',
			'ObtainTheDeviceTemplate': '获取设备模版',
			'ToChannel': '导入',
			'accomplish': '完成',
			'DeviceList': "设备列表",
			'QrcodeBinding': '二维码绑定',
			'DeviceQRcodeZip': '设备二维码.zip',
			'DeviceListExportZip': '设备列表导出.zip',
			'Bound': "已绑定",
			'NotBound': "未绑定",
			'UnabletoBound': "无法绑定",
			'ImportDevice': "导入设备",
			'EquipmentAssetCoding': '设备资产编码',
			'DocumentType': '文档（WORD,EXCEL,PPT,PDF）',
			'SearchDocumentName': '搜索文档名称',
			'NoFileHasBeenUploaded': '暂未上传文档',
			'NoPictureVideoHasBeenUploaded': '暂未上传图片视频',
			'FullLifeCircle': '全生命周期',
			'AssociatedGroupTypeDevice': '关联机组类型设备',
			'AssociatedIndividualDevice': '关联单体设备',
			'risk': "危险",
			'FailedToObtainDeviceDetailsPleaseTryAgain': '获取设备详情失败,请重试！',
			"total_equipment":"设备总量",
			"annual_equipment_installed_capacity":"年度设备装机量",
			please_rename_the_file_and_try_uploading_again:"文件名只能包含中文字符、字母（大小写）、数字和下划线，请修改名称后重新上传。",
		},
		"business-partner": {
			text: "商业伙伴",
			manufacturer: "设备制造商",
			"service-company": "代理商",
			customer: "客户",
		},
		"system-management": {
			text: "系统管理",
			"role-management": "角色管理",
			"user-management": "用户管理",
			"energy-consumption-allocation":"能耗配置"
		},
		"intelligent-operation-maintenance": {
			text: "智能运维",
			"health-monitor": "健康监控",
			"event": "事件管理",
			"data-analysis": "图谱分析",
			"expert-service": "专家系统服务",
			"intelligent-diagnosis":"智能诊断"

		},

	},
	manufacturer: {
		text: '设备制造商',
		'email-error': '邮箱格式错误',
		'error': '出现错误',
		'device-manufacturer-name': '设备制造商名称',

	},
	serviceCompany: {
		'certificate_name': '证书名称',
		'awarding_body': '颁发机构',
		'not_null': '（必填）',
		'indate': '有效期',
		'certificate_photo': '证书照片',
		'begin_date': '开始日期',
		'end_date': '结束日期',
		'create_success': '创建成功',
		'company_name': '公司名称',
	},
	also: {
		'support': '支持',
		'FileSizeDoesNotExceed': '文件大小不超过',
		'ClickUpload': '点击上传',
		'ProductLibraryContainsDefinitions': '产品库包含了一类设备的通用属性名称、层级和方法名称的定义。',
		'ParentProduct': '父类产品',
		'ExpectedDate': '期望服务日期',
		'PropertyDeviceThatNotChangeEasily': '设备中不易变化或根本不会变化的属性。例如序列号、安装日期、额定功率等。',
		'FrequentlyChangingPropertiesDevice': "设备中频繁变化的属性。例如瞬时电流、电压、振动等。",
		'CreateMaintenanceItems': '创建维护保养项。',
		'ProductRelatedDiagramsVideosDocuments': '产品相关图、视频、文档。',
		'UsedToRetrieveProducts': '用于检索产品。',
		'BusinessInformation': '商务信息',
		'CharacterString': "字符串",
		'integer': '整数',
		'double-precisionNumber': '双精度数',
		'boolean': '布尔值',
		'last name': '姓',
		'first name': '名',
		'total': '合计:',
		'item': '条',
		'next page': '下一页',
		'jump to': '跳转至',
		'page': '页',
		'previous page': '上一页',
		'please select': '请选择',
		'SelectingTheEquipment': '选择设备',
		'inAll': '共',
		'SuperAdmin': '超级管理员',
		'EquipmentManager': '设备管理人',
		'IntelligentOperationPlatform': '智能化运维管理平台',
	},

	province: {
		"中国":"中国",
		"北京": "北京市",
		"天津": "天津市",
		"河北": "河北省",
		"山西": "山西省",
		"内蒙古": "内蒙古自治区",
		"辽宁": "辽宁省",
		"吉林": "吉林省",
		"黑龙江": "黑龙江省",
		"上海": "上海市",
		"江苏": "江苏省",
		"浙江": "浙江省",
		"安徽": "安徽省",
		"福建": "福建省",
		"江西": "江西省",
		"山东": "山东省",
		"河南": "河南省",
		"湖北": "湖北省",
		"湖南": "湖南省",
		"广东": "广东省",
		"广西": "广西壮族自治区",
		"海南": "海南省",
		"重庆": "重庆市",
		"四川": "四川省",
		"贵州": "贵州省",
		"云南": "云南省",
		"西藏": "西藏自治区",
		"陕西": "陕西省",
		"甘肃": "甘肃省",
		"青海": "青海省",
		"宁夏": "宁夏回族自治区",
		"新疆": "新疆维吾尔自治区",
		"香港": "香港特别行政区",
		"澳门": "澳门特别行政区",
		"台湾": "台湾省",
		"北京市": "北京市",
		"天津市": "天津市",
		"河北省": "河北省",
		"山西省": "山西省",
		"内蒙古自治区": "内蒙古自治区",
		"辽宁省": "辽宁省",
		"吉林省": "吉林省",
		"黑龙江省": "黑龙江省",
		"上海市": "上海市",
		"江苏省": "江苏省",
		"浙江省": "浙江省",
		"安徽省": "安徽省",
		"福建省": "福建省",
		"江西省": "江西省",
		"山东省": "山东省",
		"河南省": "河南省",
		"湖北省": "湖北省",
		"湖南省": "湖南省",
		"广东省": "广东省",
		"广西壮族自治区": "广西壮族自治区",
		"海南省": "海南省",
		"重庆市": "重庆市",
		"四川省": "四川省",
		"贵州省": "贵州省",
		"云南省": "云南省",
		"西藏自治区": "西藏自治区",
		"陕西省": "陕西省",
		"甘肃省": "甘肃省",
		"青海省": "青海省",
		"宁夏回族自治区": "宁夏回族自治区",
		"新疆维吾尔自治区": "新疆维吾尔自治区",
		"香港特别行政区": "香港特别行政区",
		"澳门特别行政区": "澳门特别行政区",
		"台湾省": "台湾省",
		"南海诸岛": "南海诸岛",
		"出口":"出口",
	},

	'所属机组序列号': '所属机组序列号',
	'设备名称': '设备名称',
	'设备厂商': '设备厂商',
	'设备品牌': '设备品牌',
	'设备型号': '设备型号',
	'额定电流': '额定电流',
	'序列号': '序列号',
	'发货时间': '发货时间',
	'设备状态': '设备状态',
	'设备创建时间': '设备创建时间',
	'设备资产编码': '设备资产编码',
	'质保开始时间': '质保开始时间',	
	'质保到期时间': '质保到期时间',
	'应用行业': '应用行业',
	'所在位置': '所在位置',
	'详细地址': '详细地址',
	'应用车间': '应用车间',
	'应用工艺': '应用工艺',
	'设备联系人': '设备联系人',
	'设备联系电话': '设备联系电话',
	'维保服务商': '维保服务商',
	'客户名称': '客户名称',
	'客户编码': '客户编码',
	'客户属性': '客户属性',
	'客户行业': '客户行业',
	'客户地址': '客户地址',
	'客户电话': '客户电话',
	'客户邮箱': '客户邮箱',
	'客户官网': '客户官网',
	'客户采购联系人': '客户采购联系人',
	'客户采购联系人电话': '客户采购联系人电话',
	'GDNC订单号': 'GDNC订单号',
	'GNDC订单号': 'GNDC订单号',
	'销售渠道': '销售渠道',
	'销售': '销售',
	'设备出厂信息': '设备出厂信息',
	'设备管理信息': '设备管理信息',
	'商务信息': '商务信息',
	'无': '无',
	'在用': '在用',
	'备用': '备用',
	'报废': '报废',
	"制糖": "制糖",
	"制药": "制药",
	"化工": "化工",
	"医疗": "医疗",
	"医药": "医药",
	"啤酒": "啤酒",
	"市政": "市政",
	"有机硅": "有机硅",
	"核电": "核电",
	"氨纶": "氨纶",
	"污水": "污水",
	"油气": "油气",
	"炭黑": "炭黑",
	"烟草": "烟草",
	"煤化工": "煤化工",
	"煤炭": "煤炭",
	"煤矿": "煤矿",
	"电力": "电力",
	"电子": "电子",
	"石化": "石化",
	"矿业": "矿业",
	"粮油": "粮油",
	"纤维": "纤维",
	"设备": "设备",
	"轮胎": "轮胎",
	"通用": "通用",
	"造纸": "造纸",
	"造纸配套户": "造纸配套户",
	"配套": "配套",
	"酵母": "酵母",
	"钢铁": "钢铁",
	"铝业": "铝业",
	"铸造": "铸造",
	"食品": "食品",
	"非KA": "非KA",
	"普通": "普通",
	"KA": "KA",
	"配套户": "配套户",
	"工程公司": "工程公司",
	"出口": "出口",
	"设备管理": "设备管理",
	"售后服务": "售后服务",
	"商业伙伴": "商业伙伴",
	"系统管理": "系统管理",
	"个人中心": "个人中心",
	"产品库": "产品库",
	"查看产品信息": "查看产品信息",
	"新建产品": "新建产品",
	"编辑产品": "编辑产品",
	"查看产品文件资料": "查看产品文件资料",
	"删除产品": "删除产品",
	"查看设备详情": "查看设备详情",
	"添加设备": "添加设备",
	"编辑设备": "编辑设备",
	"删除设备": "删除设备",
	"二维码绑定": "二维码绑定",
	"服务请求": "服务请求",
	"查看": "查看",
	"添加": "添加",
	"编辑": "编辑",
	"工单管理": "工单管理",
	"确认派工": "确认派工",
	"申请转派": "申请转派",
	"编辑接单服务商信息": "编辑接单服务商信息",
	"编辑接单工程师信息": "编辑接单工程师信息",
	"其它信息编辑": "其它信息编辑",
	"工单受理人": "工单受理人",
	"服务报告": "服务报告",
	"附件上传": "附件上传",
	"附件下载": "附件下载",
	"商机管理": "商机管理",
	"保养计划": "保养计划",
	"设备制造商": "设备制造商",
	"其余信息": "其余信息",
	"企业账户": "企业账户",
	"代理商": "代理商",
	"终端客户": "终端客户",
	"权限管理": "权限管理",
	"用户管理": "用户管理",
	"列表": "列表",
	"冻结": "冻结",
	"修改": "修改",
	"重置密码": "重置密码",
	"角色管理": "角色管理",
	"删除": "删除",
	"个人信息": "个人信息",
	"企业信息": "企业信息",
	"下载中": "下载中...",
	// 智能运维页面
	smart_OM_model:{
		smart_OM:"智能运维",
		start_time:"开启时间",
		end_time:"关闭时间",
		model_status:"智控状态",
		real_time_monitoring:"实时监控",
		intelligent_total_running_time:"智控累计运行时间",
		key_metrics_trend:"关键指标趋势",
		model_logs:"智能运行日志",
		last_updated:"最近更新时间",
		items_selected:"项已选",
		condenser:"凝汽器",
		pressure:"压力",
		temperature:"温度",
		power:"运行功率",
		motor_frequency:"运行频率",
		flow_rate:"流量",
		current:"运行电流",
		motor_speed:"运行转速",
		valve:"阀门",
		separator_level:"汽水分离器液位",
		open:"开启",
		closed:"关闭",
		t_sealing_water:"液环泵工作液温度",
		liquid_ring:"3#液环真空泵",
		two_roots:"2#罗茨泵",
		one_roots:"1#罗茨泵",
		water_pump:"高速给水泵",
		two_speed_pump:"双速给水泵",
		high_speed:"高速状态",
		low_speed:"低速状态",
		activate_smart_OM_modle:"激活智能运维模式吗？",
		close_smart_OM_modle:"关闭智能运维模式吗?"
	},
	// 智能运维页面---造纸厂
	smart_OM_model_paper_making:{
		fault_name:"故障名称",
		surge:"喘振",
		gradual_increase_in_vibration_levels:"振动缓慢增加(振动水平从一开始的0.3-09经过几个月的运行增长到2.0以上)",
		residual_fibers_and_other_particulates_remaining_after:"经过过滤剩余的纤维等附着在叶轮上导致振动增加",
		we_have_developed_an_intelligen_spray:"我方针对此类问题开发智能喷淋系统，可有效较低叶轮清洗时间",
		sudden_increase_in_vibration_fluctuations:"振动突然增加，真空度波动",
		a_sudden_drop_in_system_pumping_speed_due:"系统抽速由于工艺等原因突然降低导致透平机进入喘振区",
		we_provide_an_intelligent_antisurge_control_logic:"提供智能防喘控制逻辑，正常运行时无法进入喘振区，工艺原因导致设备即将进入喘振时即自动开启补气阀",
		energy_efficiency_realtime_monitoring:"能效实时监测",//能效实时监测
		suction_volumetric_flow:"吸入体积流量 [m³/s]",
		vacuum:"真空度 [kPa]",
		surge_warning:"喘振预警",
		this_inspection_indicates_good:"本次监测健康，无喘振风险，无结垢风险",
	}
}
